/*jshint unused:false*/
/*global fetch */
/*global console */

// Csrf Token
let form_token;
const keepTokenAlive = async function () {
  try {
    const resp = await fetch('/account/token', {
      method: 'GET',
    });
    if (resp.ok) {
      const data = await resp.json();
      if (data.token) {
        document.querySelectorAll('[name="_token"]').forEach(v => {
          v.setAttribute('value', data.token);
        });
        form_token = data.token;
      } else {
        console.log('Token not found in response');
      }
    } else {
      console.log(`Error: ${resp.status} ${resp.statusText}`);
    }
  } catch (error) {
    console.error('Fetch error:', error);
  }
};
document.addEventListener('DOMContentLoaded', (event) => {
  keepTokenAlive(); // Refresh token on page load
  setInterval(keepTokenAlive, 15 * 60 * 1000); // Refresh token every 15 minutes
});
// END Csrf Token


setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
}, 2000);
document.addEventListener("DOMContentLoaded", function() {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});

const searchButton = true;

// Price toggles
let typeQueryString  = document.body.dataset.type || '';
let allSwitches      = Array.from(document.querySelectorAll('.price-toggle'));
let priceContainers  = Array.from(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm  = document.getElementById('price-switch');
let selected;  // 0 = Personal, 1 = Business

allSwitches.forEach(switchEl => {
    // Jurni listens on both click and change
    switchEl.addEventListener('click', () => {});
    switchEl.addEventListener('change', e => {
        const target = e.composedPath()[0];
        // figure out whether user picked Personal or Business
        selected = target.classList.contains('toggle-personal') ? 0 : 1;
        if (target.classList.contains('price-toggle-checkbox')) {
            // the little standalone checkbox flips it too
            selected = target.checked ? 1 : 0;
        }
        toggleSwitches();
        togglePrices();
        updatePrice();
        hidePOA();
    });
});

function toggleSwitches() {
    // check the correct radio(s) inside each .price-toggle container
    allSwitches.forEach(container => {
        container.querySelectorAll('.toggle-personal')
                 .forEach(i => i.checked = (selected === 0));
        container.querySelectorAll('.toggle-business')
                 .forEach(i => i.checked = (selected === 1));
    });

    // update any .price-toggle-checkbox switches by class (Crusader uses classes, not a single ID)
    document.querySelectorAll('.price-toggle-checkbox')
            .forEach(cb => cb.checked = (selected === 1));

    // sync the hidden form field if it exists
    const switchInput = document.querySelector('#switch-price-type');
    if (switchInput) {
        switchInput.value = selected === 0 ? 'Personal' : 'Business';
    }

    // update any titles on the page
    document.querySelectorAll('.price-title-type').forEach(el => {
        el.innerHTML = selected === 0 ? 'Personal' : 'Business';
    });
}

function togglePrices() {
    priceContainers.forEach(container => {
        const per = container.querySelector('.price-personal');
        if (per) per.classList.toggle('active', selected === 0);
        const biz = container.querySelector('.price-business');
        if (biz) biz.classList.toggle('active', selected === 1);
    });
}

function updatePrice() {
    if (!priceSwitchForm) return;  // no price‑switch form on this page

    const url      = priceSwitchForm.getAttribute('action');
    const formData = new FormData(priceSwitchForm);

    fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'X-CSRF-TOKEN': document.querySelector('#price-switch [name=_token]').value,
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(res => {
        if (res.status !== 200) {
            console.warn('Price‑toggle fetch status:', res.status);
            return null;
        }
        return res.json();
    })
    .then(data => {
        if (data && data.token) {
            const tokenInput = document.querySelector('#price-switch [name=_token]');
            if (tokenInput) tokenInput.value = data.token;
        }
    })
    .catch(err => console.error('Price toggle error:', err));
}

function hidePOA() {
    const dealBoxes = document.querySelectorAll('.search .deal-box');
    if (!dealBoxes.length) return;

    priceContainers.forEach(container => {
        const per = container.querySelector('.price-personal');
        if (per && selected === 0) {
            dealBoxes.forEach(el => {
                el.classList.toggle('hidden', el.dataset.poaPersonal === 'true');
            });
        }
        const biz = container.querySelector('.price-business');
        if (biz && selected === 1) {
            dealBoxes.forEach(el => {
                el.classList.toggle('hidden', el.dataset.poaBusiness === 'true');
            });
        }
    });
}

// on page‑load, bootstrap whatever the URL/data-type is
if (/personal/i.test(typeQueryString) || /business/i.test(typeQueryString)) {
    selected = /personal/i.test(typeQueryString) ? 0 : 1;
    toggleSwitches();
    togglePrices();
    updatePrice();
    hidePOA();
}

// End price Toggles

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}

let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

/* MOBILE MODALS */
// const navContainer = document.querySelector('.main-header-inner');
// const hamburger = document.querySelector('#hamburger');

// const modalMobileNav = new tingle.modal({
//   footer: false,
//   closeMethods: ['escape'],
//   cssClass: ['mobile-nav','reversed']
// });
// modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);

// Nav modal
// const handleToggle = () => {
//   hamburger.classList.toggle('active');
//   hamburger.classList.toggle('is-active');
//   navContainer.classList.toggle('is-active');

//   if(hamburger.classList.contains("active")) {
//     modalMobileNav.open();
//   } else{
//     modalMobileNav.close();
//   }
// }

// Sticky class for navbar & modal
// window.onscroll = function() {stickyNav()};
// let navbar = document.getElementById('navbar');
// let tingleModal = document.querySelector('.tingle-modal');
// let sticky = navbar.offsetTop;
// function stickyNav() {
//   if (!document.body.classList.contains('tingle-enabled')) {
//     if (window.pageYOffset >= sticky) {
//       navbar.classList.add('is-sticky')
//       tingleModal.classList.add('is-sticky')
//     } else {
//       navbar.classList.remove('is-sticky')
//       tingleModal.classList.remove('is-sticky')
//     }
//   }
// }

// hamburger.onclick = () => handleToggle();
// hamburger.addEventListener('keyup', (event) => {
//   if(event.keyCode === 13 || event.keyCode === 32) {
//     handleToggle();
//   }
// });
/* END MOBILE MODALS */

// Toggle search bar
//   document.getElementById('toggle-search') ? document.getElementById('toggle-search').addEventListener('click', () => {
//     document.querySelector('.header-search').classList.toggle('active');
//     document.querySelector('.search-opener').classList.toggle('active');
//   }) : '';

// Toggle loader when searching
  document.querySelector('.search-button') ? [].slice.call(document.querySelectorAll('.search-button')).forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.remove('loaded')
    })
  }) : '';


// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('.header-content');
if(showMoreButton){
  if (showMoreButton.parentElement.parentElement.querySelectorAll('.header-description > *')) {
    showMoreButton.addEventListener('click', (e) => {
      // console.log('click')
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}
// END Show More


//Dropdown Menu Toggle
const delayTime = 90;
let hideTimeout;

const showMenu = function() {
  const dropdown = this.parentNode.querySelector('div');
  const menuToggle = this;

  const activeClass = document.querySelectorAll(".dropdown-menu .active");
  if (activeClass) {
    activeClass.forEach((item) => {
      item.classList.remove("active", "is-active");
    });
  }

  clearTimeout(hideTimeout);

  dropdown.classList.add("active", "is-active");
  menuToggle.classList.add("active", "is-active");
};

const hideMenu = function() {
  const dropdown = this.parentNode.querySelector('div');
  const menuToggle = this;

  hideTimeout = setTimeout(() => {
    dropdown.classList.remove("active", "is-active");
    menuToggle.classList.remove("active", "is-active");
  }, delayTime);
};

const toggleMenu = function() {
  const dropdown = this.parentNode.querySelector('div');

  if (dropdown.classList.contains("active")) {
    hideMenu.call(this);
  } else {
    showMenu.call(this);
  }
};

const setupEventListeners = () => {
  const menuDropdown = document.querySelectorAll(".dropdown-menu > a");
  const isDesktop = window.innerWidth >= 1281;

  menuDropdown.forEach((menu) => {
    const dropdown = menu.parentNode.querySelector('div');
  
    menu.removeEventListener('click', toggleMenu);
    menu.addEventListener('click', toggleMenu);
  });
};
window.addEventListener('resize', setupEventListeners);
window.addEventListener('DOMContentLoaded', setupEventListeners);

//faqs
// var faqSearch = document.querySelector('.faq-search input');
//
// if(faqSearch !== null){
//   faqSearch.addEventListener('keyup', function(e){
//     var results = document.getElementById('faq-results');
//     if(this.value.length != 0){
//       results.classList.add("active");
//     } else {
//       results.classList.remove("active");
//     }
//   });
// }

//More Options Toggle
// var classname = document.querySelectorAll(".more-options");
//
// var moreOptions = function(e) {
// 	e.preventDefault();
//   var element = document.getElementById("vehicle-search");
//   element.classList.toggle("active");
//   if(element.classList.contains('active')){
//     this.innerHTML = 'Hide additional options';
//   } else {
//     this.innerHTML = 'Show me more options';
//   }
// };
// for (var i = 0; i < classname.length; i++) {
//     classname[i].addEventListener('click', moreOptions, false);
// }

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}


// Contact Form
if(document.getElementById('send-contact-form')){

  document.getElementById('name').addEventListener('input', function() {
    let fullName = this.value.trim();
    let nameParts = fullName.split(' ');

    let forename = nameParts.length > 0 ? nameParts[0] : '';
    let surname = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

    document.getElementById('company').value = fullName;
    document.getElementById('forename').value = forename;
    document.getElementById('surname').value = surname;
  });

  let constraints = {
    full_name: {
      presence: {allowEmpty: false},
      length: {
        minimum: 5,
        message: "must be at least 5 characters"
      },
      format: {
        pattern: /^\S+\s+\S+.*$/,
        message: "must consist of at least two words"
      }
    },
    first_name: {
      presence: {allowEmpty: false},
      length: {
        minimum: 3,
        message: "must be at least 3 characters"
      }
    },
    last_name: {
      presence: {allowEmpty: false},
      length: {
        minimum: 3,
        message: "must be at least 3 characters"
      }
    },
    company: {
      presence: {allowEmpty: false},
      length: {
        minimum: 3,
        message: "must be at least 3 characters"
      }
    },
    email_address: {
      email: {
        message: function(value) {
          return validate.format("^<strong>%{em}</strong> is not a valid email", {
            em: value
          });
        }
      }
    },
    telephone: {
      presence: {allowEmpty: false},
      numericality: {
        message: "must only contain numbers"
      },
      format: {
        pattern: /^(07|7|44|\+44|0[1-3]).*$/,
        message: function(value) {
          return validate.format("^<strong>%{num}</strong> is not a valid telephone number", {
            num: value
          });
        }
      },
      length: {
        minimum: 10,
        maximum: 12
      }
    }
  };
  let availableFields = [];
  document.querySelectorAll('#contact-form [data-validate]').forEach((v)=>{
    availableFields.push(v.dataset.validate);
  })
  let availableConstraints = Object.fromEntries(availableFields.map(col => [col, constraints[col]]));

  document.querySelectorAll('#contact-form [data-validate]').forEach((v)=>{
    if(v && v.value) { setTimeout(() => { v.dispatchEvent(new Event('keyup')) }, 500) }
    v.addEventListener('keyup', (e) => {
      let isValid = validate({
        full_name: (document.querySelector('#name')) ? document.querySelector('#name').value : null,
        first_name: (document.querySelector('#forename')) ? document.querySelector('#forename').value : null,
        last_name: (document.querySelector('#surname')) ? document.querySelector('#surname').value : null,
        company: (document.querySelector('#company')) ? document.querySelector('#company').value : null,
        title: (document.querySelector('#title')) ? document.querySelector('#title').value : null,
        enquiry_type: (document.querySelector('#enquiry-type')) ? document.querySelector('#enquiry-type').value : null,
        email_address: (document.querySelector('#email')) ? document.querySelector('#email').value : null,
        telephone: (document.querySelector('#telephone')) ? document.querySelector('#telephone').value.replace(/\s/g, '') : null,
        address: (document.querySelector('#address')) ? document.querySelector('#address').value : null,
        town: (document.querySelector('#town')) ? document.querySelector('#town').value : null,
        postcode: (document.querySelector('#postcode')) ? document.querySelector('#postcode').value : null,
      }, availableConstraints)

      let field = e.target.dataset.validate;
      if (isValid === undefined) {
        //console.log('all valid')
        document.querySelector('#send-contact-form').disabled = false;
        document.querySelectorAll(`#contact-form [data-validate]`).forEach(v=>{v.classList.remove('invalid')});
        document.querySelectorAll(`#contact-form .validation-error`).forEach(v=>{v.remove()});
      } else {
        document.querySelector('#send-contact-form').disabled = true;
        if (isValid[field] === undefined) {
          //console.log('field valid')
          document.querySelector(`#contact-form [data-validate=${field}]`).classList.remove('invalid');
          document.querySelectorAll(`#contact-form [data-validate=${field}] ~ .validation-error`).forEach(v=>{v.remove()});
        } else {
          //console.log('field invalid')
          document.querySelectorAll(`#contact-form [data-validate=${field}] ~ .validation-error`).forEach(v=>{v.remove()});
          if(e.target.type !== 'checkbox') {
            document.querySelector(`#contact-form [data-validate=${field}]`).classList.add('invalid');
            isValid[field].forEach(v => {
              let error = document.createElement("p");
              error.classList.add('validation-error');
              error.innerHTML = `${v}`;
              document.querySelector(`#contact-form [data-validate=${field}]`).parentElement.appendChild(error);
            })
          }
        }
      }
    })
  })

  let button = document.querySelector('#send-contact-form');

  document.getElementById('send-contact-form').addEventListener("click", function(e) {
    e.preventDefault();

    for (const el of document.getElementById('contact-form').querySelectorAll("[required]")) {
      if (!el.reportValidity()) {
        return alert('Please fill all required fields!');
      }
    }

    document.body.classList.remove('loaded');
    button.disabled = true;
    button.innerHTML = 'Sending...';

    // Do captcha and submit form
    grecaptcha.ready(function() {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let form_type = document.getElementById('form_type') ? document.getElementById('form_type').value : 'General Contact';
        let token = document.querySelector('#contact-form [name=_token]').value;
        let deal_type = 'Business - Contract Hire';
        let title = '';
        let forename = '';
        let surname = '';
        let name = '';
        let company = '';
        let email = '';
        let telephone = '';
        let comments = '';
        let address = '';
        let town = '';
        let postcode = '';
        let registration = '';
        let mileage = '';
        let car_id = '';
        let vehicle_type = '';
        let make_model = '';
        let extras = '';
        let purchase_method = '';
        let part_exchange = '';
        let range = '';
        let model = '';

        let van_id = '';
        let initial_payment = '';
        let vehicle_name = '';
        let cap_id = '';
        let monthly_rental = '';

        let alternative_mailto = false;
        let alternative_mailto2 = false;

        title = document.querySelector('#contact-form [name=title]') ? document.querySelector('#contact-form [name=title]').value : '';
        company = document.querySelector('#contact-form [name=company]') ? document.querySelector('#contact-form [name=company]').value : document.querySelector('#contact-form [name=name]').value;
        forename = document.querySelector('#contact-form [name=forename]') ? document.querySelector('#contact-form [name=forename]').value : '';
        surname  = document.querySelector('#contact-form [name=surname]')  ? document.querySelector('#contact-form [name=surname]').value  : '';

        // make company/name = forename + surname
        const fullName = `${forename} ${surname}`.trim();
        company = fullName;
        document.querySelector('#contact-form [name="company"]')?.setAttribute('value', fullName);

        name = fullName;
        document.querySelector('#contact-form [name="name"]')?.setAttribute('value', fullName);
        
        email = document.querySelector('#contact-form [name=email]') ? document.querySelector('#contact-form [name=email]').value : '';
        telephone = document.querySelector('#contact-form [name=telephone]') ? document.querySelector('#contact-form [name=telephone]').value : '';
        comments = document.querySelector('#contact-form [name=comments]') ? document.querySelector('#contact-form [name=comments]').value : '';
        registration = document.querySelector('#contact-form [name=registration]') ? document.querySelector('#contact-form [name=registration]').value : '';
        mileage = document.querySelector('#contact-form [name=mileage]') ? document.querySelector('#contact-form [name=mileage]').value : '';
        make_model = document.querySelector('#contact-form #custom_1') ? document.querySelector('#contact-form #custom_1').value : '';
        extras = document.querySelector('#contact-form #custom_2') ? document.querySelector('#contact-form #custom_2').value : '';
        purchase_method = document.querySelector('#contact-form #custom_3') ? document.querySelector('#contact-form #custom_3').value : '';
        part_exchange = document.querySelector('#contact-form #custom_4') ? document.querySelector('#contact-form #custom_4').value : '';
        range = document.querySelector('#contact-form [name=range]') ? document.querySelector('#contact-form [name=range]').value : '';
        model = document.querySelector('#contact-form [name=model]') ? document.querySelector('#contact-form [name=model]').value : '';
        van_id = document.querySelector('#contact-form [name=van_id]') ? document.querySelector('#contact-form [name=van_id]').value : '';
        initial_payment = document.querySelector('#contact-form [name=initial_payment]') ? document.querySelector('#contact-form [name=initial_payment]').value : '';
        vehicle_name = document.querySelector('#contact-form [name=vehicle_name]') ? document.querySelector('#contact-form [name=vehicle_name]').value : '';
        vehicle_type = document.querySelector('#contact-form [name=vehicle_type]') ? document.querySelector('#contact-form [name=vehicle_type]').value : '';
        cap_id = document.querySelector('#contact-form [name=cap_id]') ? document.querySelector('#contact-form [name=cap_id]').value : '';
        monthly_rental = document.querySelector('#contact-form [name=monthly_rental]') ? document.querySelector('#contact-form [name=monthly_rental]').value : '';
        
        alternative_mailto = document.querySelector('#contact-form [name=alternative-mailto]') ? document.querySelector('#contact-form [name=alternative-mailto]').value : false;
        alternative_mailto2 = document.querySelector('#contact-form [name=alternative-mailto2]') ? document.querySelector('#contact-form [name=alternative-mailto2]').value : false;
        // deal_type = document.querySelector('#contact-form [name=deal_type]') ? document.querySelector('#contact-form [name=deal_type]').value : 'Business - Contract Hire';


        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'alternative-mailto': alternative_mailto,
            'alternative-mailto2': alternative_mailto2,
            'deal_type': deal_type,
            'type': form_type,
            'car_id': car_id,
            'van_id': van_id,
            'initial_payment': initial_payment,
            'title': title,
            'name': name,
            'forename': forename,
            'surname': surname,
            'company': company,
            'address': address,
            'town': town,
            'postcode': postcode,
            'email': email,
            'telephone': telephone,
            'cap_id': cap_id,
            'vehicle_type': vehicle_type,
            'monthly_rental': monthly_rental, 
            'comments': `COMMENTS: ${comments} ${registration ? '\n\r ---- REGISTRATION: ' + registration : ''} ${mileage ? '\n\r ---- MILEAGE: ' + mileage : ''} ${make_model ? '\n\r ---- VEHICLE MANUFACTURER & MODEL: ' + make_model : ''} ${extras ? '\n\r ---- VEHICLE EXTRAS: ' + extras : ''} ${purchase_method ? '\n\r ---- PREFERRED METHOD OF PURCHASE: ' + purchase_method : ''} ${part_exchange ? '\n\r ---- PART EXCHANGE: ' + part_exchange : ''} ${range ? '\n\r ---- RANGE: ' + range : ''} ${model ? '\n\r ---- MODEL: ' + model : ''} ${van_id ? '\n\r ---- VAN ID: ' + van_id : ''} ${vehicle_name ? '\n\r ---- VEHICLE NAME: ' + vehicle_name : ''} ${initial_payment ? '\n\r ---- INITIAL PAYMENT: ' + initial_payment : ''}`,
            '_token': token,
            'g-recaptcha-response': recaptcha_token
          }),
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          document.body.classList.add('loaded');
          button.disabled = false;
          button.innerHTML = 'Send Enquiry';
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          if(data.status!='ok'){
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            return alert('There was a problem with your form\n\n'+errors);
          }

          // document.querySelector('.contact-form') ? document.querySelector('.contact-form').reset() : null;
          // document.querySelector('.contact-content') ? document.querySelector('.contact-content').classList.add('hidden') : null;
          // document.querySelector('.contact-details-form .thank-you') ? document.querySelector('.contact-details-form .thank-you').classList.remove('hidden') : null;
          // document.querySelector('.contact-details-form') ? document.querySelector('.contact-details-form').scrollIntoView() : null;
          const formEl   = document.getElementById('contact-form');
          formEl?.reset();

          // find a suitable container on either page type
          const container = formEl?.closest('.contact-details-form, .quote-form-outer') || formEl?.parentElement;

          // hide the form block (contact page = .contact-content, range page = .quote-form-ctr)
          const content   = container?.querySelector('.contact-content, .quote-form-ctr') || formEl;

          // show the thank-you (present in both when added to range)
          const thanks    = container?.querySelector('.thank-you');

          content?.classList.add('hidden');
          thanks?.classList.remove('hidden');
          container?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });


          // Trigger event tracking form_type
          if (form_type == 'General Contact') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Contact Form Submit'
            });
          } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': form_type + ' Form Submit'
            });
          }


        }).catch(function(err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });
      });
    });

  });
}

// Newsletter Form
if(document.getElementById('email-signup')){
  let forename = '';
  let surname = '';

  document.getElementById('newsletter-name').addEventListener('input', function() {
    let fullName = this.value.trim();
    let nameParts = fullName.split(' ');

    forename = nameParts.length > 0 ? nameParts[0] : '';
    surname = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

    document.getElementById('newsletter-company').value = fullName;
    document.getElementById('newsletter-forename').value = forename;
    document.getElementById('newsletter-surname').value = surname;
  });

  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    let url = '/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let name = document.getElementById('newsletter-name').value;
    let token = document.getElementsByName('_token')[0].value;
    let deal_type = 'Business - Contract Hire';
    
    if (name.trim().length < 3) {
      alert('Please enter your full name (at least 3 characters).');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      alert('Please enter a valid email address.');
      return;
    }

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ 'name': name,'full_name': name, 'first_name': forename, 'forename': forename, 'company': name, 'surname': surname,'deal_type': deal_type, 'email': email, '_token': token }),
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        return alert('There was a problem with your sign up details\n\n'+ errors);
      }

      document.getElementsByClassName('footer-newsletter-form')[0].reset();
      document.cookie = "newsletter_dismissed=true";

      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Form Submit'
      });
      return alert('Thank you!');

    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  });
}

// SEARCH SIDEBAR
function setUrlParams(param, value, module) {
  let searchUrl = new URL(window.location.origin + window.location.pathname);
  if (module === 'Search') {
    if (window.location.search.includes('offers=specials')) {
      searchUrl.searchParams.set('offers', 'specials');
    } else if (window.location.search.includes('offers=stock')) {
      searchUrl.searchParams.set('offers', 'stock');
    }
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
  } else if (window.location.pathname === '/car-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
  } else if (window.location.pathname === '/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/van-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
  } else if (window.location.pathname === '/van-leasing/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/van-leasing/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/pick-up-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.append('body_type', 'Pick-up');
  } else {
    (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
    (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
    searchUrl.searchParams.set('filter', 'true');
  }
  if(param==='type'){
    searchUrl.searchParams.set('search-type', value);
    searchUrl.searchParams.set('make', '');
    searchUrl.searchParams.set('model', '');
    searchUrl.searchParams.delete('body_type');
  } else {
    searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside input[name="make"]:checked') ? document.querySelector('.search-aside input[name="make"]:checked').value : ''));
    searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside input[name="model"]:checked') ? document.querySelector('.search-aside input[name="model"]:checked').value : ''));
    // param==='make' ? searchUrl.searchParams.set('model', '') : null;

    if(window.location.pathname !== '/pick-up-leasing'){
      searchUrl.searchParams.set('body_type', (param==='body_type') ? value : (document.querySelector('.search-aside input[name="body_type"]:checked') ? document.querySelector('.search-aside input[name="body_type"]:checked').value : ''));
    }

    if(param==='make'){
      searchUrl.searchParams.delete('model');
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='model'){
      searchUrl.searchParams.delete('van_size');
      searchUrl.searchParams.delete('body_type');
    }
  }

  searchUrl.searchParams.set('fuel_type', param==='fuel_type' ? value : (document.querySelector('.search-aside input[name="fuel_type"]:checked') ? document.querySelector('.search-aside input[name="fuel_type"]:checked').value : ''));
  searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside input[name="transmission"]:checked') ? document.querySelector('.search-aside input[name="transmission"]:checked').value : ''));
  searchUrl.searchParams.set('seats', param==='seats' ? value : (document.querySelector('.search-aside input[name="seats"]:checked') ? document.querySelector('.search-aside input[name="seats"]:checked').value : ''));

  searchUrl.searchParams.set('term', param==='term' ? value : (document.querySelector('.search-filters [name="term"]') ? document.querySelector('.search-filters [name="term"]').value : ''));
  searchUrl.searchParams.set('initial_profile', param==='initial_profile' ? value : (document.querySelector('.search-filters [name="initial_profile"]') ? document.querySelector('.search-filters [name="initial_profile"]').value : ''));
  searchUrl.searchParams.set('mileage', param==='mileage' ? value : (document.querySelector('.search-filters [name="mileage"]') ? document.querySelector('.search-filters [name="mileage"]').value : ''));

  searchUrl.searchParams.set('order', param==='order' ? value : (document.querySelector('.search-filters select[name="order"]') ? document.querySelector('.search-filters select[name="order"]').value : ''));

  window.location.href = searchUrl;
}

// Show Only Filters
function updateSearchToggles() {
  let searchToggles = document.querySelectorAll('.search-form .stock input');
  if (searchToggles) {
    if (!searchButton) {
      searchToggles.forEach(value => {
        value.addEventListener('change', (e) => {
          let searchUrl = new URL(window.location.origin + '/car-leasing');
          let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
          (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
          (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Electric') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Hybrid') : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=', 'offers=stock')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('?', '?offers=stock&')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=stock&')) : null;
          (e.target.value === 'stock' && !e.target.checked && window.location.search.includes('offers=stock')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=')) : null;
          window.location.href = searchUrl;
        })
      })
    }
  }
}
// END Show Only Filters

if (searchButton){
  document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
    v.addEventListener('change', e => {
      document.querySelectorAll('#make-wrapper input').forEach(v => { v.checked = false })
      document.querySelector('.search-aside #search-type').value = document.querySelector('.search-aside input[name="search_type"]:checked').value;
      let type = document.querySelector('.search-aside #search-type').value;
      loadManufacturersRadio(type);
    })
  })
}

function loadSearchTriggers() {
  // console.log("loadSearchTriggers");
  if (document.querySelector('.search-aside') && document.querySelector('.search-filters')) {

    let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');

    if (searchButton){
      document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
        v.addEventListener('change', e => {
          selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
          document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
          loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
          let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
          (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        })
      })
    }

    if (document.querySelector('.search-aside #search-type')) {

      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);

        let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
        (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        console.log(".3");
      }

      if(document.querySelector('.search-aside #body_type-wrapper')){
        loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #fuel_type-wrapper')){
        loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #transmission-wrapper')){
        loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
      }

      (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');

      console.log("search button" + searchButton);
      if(!searchButton) {
        document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
          v.addEventListener('change', e => {
            //remove bodytype
            document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
            setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
          v.addEventListener('change', e => {
            //remove van size
            document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
            setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
        //   v.addEventListener('change', e => {
        //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
        //   })
        // })
        document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="seats"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('seats', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        if (document.querySelector('.search-filters select[name="order"]')) {
          document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
            setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        }
      }
      document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
        v.addEventListener('change', e => {
          setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
        v.addEventListener('change', e => {
          setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
        v.addEventListener('change', e => {
          setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })

      if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
        document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      // order isn't included in search options
      if (document.querySelector('.search-filters select[name="order"]')) {
        document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
          setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      }

      document.querySelectorAll('.button-clear').forEach(v => {
        v.addEventListener('click', e => {
          setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
        })
      })

      // unselectRadio('.search-form input[type=radio]');

    }
  } else {
    if (document.querySelector('#search-bar #search-type')) {
      let selectedMake = document.querySelector('#search-bar [name="make"]').options[document.querySelector('#search-bar [name="make"]').selectedIndex].value;
      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModels(document.querySelector('#search-bar #search-type').value, selectedMake.value);
      }
    }

    // if (document.querySelector('.search-aside') && document.querySelector('.derivative-wrapper')) {
    //   let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //   if (searchButton){
    //     document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //         document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
    //         loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //         let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //         (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       })
    //     })
    //   }
    //
    //   if (document.querySelector('.search-aside #search-type')) {
    //
    //     // Show Models for selected manufacturer
    //     if (selectedMake) {
    //       loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //
    //       let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //       (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       console.log(".3");
    //     }
    //
    //     if(document.querySelector('.search-aside #body_type-wrapper')){
    //       loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #fuel_type-wrapper')){
    //       loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #transmission-wrapper')){
    //       loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //
    //     (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');
    //
    //     if(!searchButton) {
    //       document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
    //           setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           //remove bodytype
    //           document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
    //           setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           //remove van size
    //           document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
    //           setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
    //       //   v.addEventListener('change', e => {
    //       //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
    //       //   })
    //       // })
    //       document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       if (document.querySelector('.search-filters select[name="order"]')) {
    //         document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
    //           setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       }
    //     }
    //     document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
    //       document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
    //       document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
    //       document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     document.querySelectorAll('.button-clear').forEach(v => {
    //       v.addEventListener('click', e => {
    //         setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     // unselectRadio('.search-form input[type=radio]');
    //
    //   }
    // }
  }
}

// Header Vans/Cars stuff
(function () {
    function forcedVT(path) {
        if (/^\/(car-leasing|cars|car-comparison|special-offers|stock|electric-leasing|hybrid-leasing)(\/|$)/.test(path)) return 'cars';
        if (path === '' || path === '/' || /^\/(van-leasing|vortex|used-vans|campers)(\/|$)/.test(path)) return 'vans';
        return null;
    }
    var path = location.pathname.replace(/\/+$/,'');
    var vt = forcedVT(path) || localStorage.getItem('vt') || 'vans';
    localStorage.setItem('vt', vt);

    // toggle page class for logo + nav
    var root = document.documentElement;
    root.classList.toggle('vt-cars', vt === 'cars');
    root.classList.toggle('vt-vans', vt !== 'cars');

    // update switcher ARIA
    var switcher = document.getElementById('vehicle-switcher');
    if (switcher) {
        var tabs = switcher.querySelectorAll('[role="tab"]');
        if (tabs.length === 2) {
            var vansTab = tabs[0], carsTab = tabs[1];
            if (vt === 'cars') {
                carsTab.setAttribute('aria-selected','true');
                carsTab.setAttribute('aria-current','page');
                vansTab.setAttribute('aria-selected','false');
                vansTab.removeAttribute('aria-current');
            } else {
                vansTab.setAttribute('aria-selected','true');
                vansTab.setAttribute('aria-current','page');
                carsTab.setAttribute('aria-selected','false');
                carsTab.removeAttribute('aria-current');
            }
        }
        switcher.addEventListener('click', function (e) {
            var a = e.target.closest('a[role="tab"]');
            if (!a) return;
            var next = a.getAttribute('href').startsWith('/car') ? 'cars' : 'vans';
            localStorage.setItem('vt', next);
        }, true);
    }
})();



function unselectRadio(groupSelector) {
  let currentId;
  document.querySelectorAll(groupSelector).forEach((elem) => {
    elem.addEventListener('click', allowUncheck);
    // needed if elem is already pre-checked
    if (elem.checked) {
      currentId = elem.id;
    }
  });

  function allowUncheck(e) {
    if (this.id === currentId) {
      this.checked = false;
      currentId = undefined;
      if (!searchButton) {
        setUrlParams(e.target.dataset.type, e.target.value, document.querySelector('.search-content').dataset.module);
      }
    } else {
      currentId = this.id;
    }
  }
}

//END Search Sidebar

// SEARCH
function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.querySelector('#search-type');
  hiddenField.setAttribute('value', searchType);
  // hiddenField.dispatchEvent(new Event('change'));

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  let slider = document.querySelector('.vehicle-type .slider');
  slider ? slider.classList.toggle("active") : null;

  if (document.querySelector('.search-aside')) {
    setUrlParams('type', searchType, document.querySelector('.search-content').dataset.module);
  } else {
    loadManufacturers(hiddenField.value);
    loadBodyTypes(hiddenField.value);
  }

}

function loadManufacturers($type) {
  if ($type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    let fuel_type = document.querySelector('input[name="fuel_type"]') ? document.querySelector('input[name="fuel_type"]').value : null;
    document.querySelectorAll('select[name="make"]').forEach((v, i) => {
      v.length = 0;
      v.add(loadingOption);
      v.selectedIndex = 0;
      let url = (fuel_type == 'Electric') ? '/api/'+$type+'/manufacturers/ev?available=yes' : '/api/'+$type+'/manufacturers/available';
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        v.length = 0;
        v.add(defaultOption);
        v.selectedIndex = 0;
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]].toLowerCase();
          option.value = keysSorted[x];
          (v.hasAttribute('data-img')) ? option.setAttribute('data-img', `/themes/crusader/img/manufacturer/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}/brandmark/mono/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}.svg`) : null;
          (v.hasAttribute('data-url')) ? option.setAttribute('data-url', `/${$type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`) : null;
          v.add(option);
        }

        let dataMakeValue = v.getAttribute('data-manufacturer');
        if (dataMakeValue) {
          v.value = dataMakeValue;
          loadModels(document.querySelector('#search-type').value, dataMakeValue);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    })
  }
}

function loadManufacturersRadio($type) {
  const wrapper = document.querySelector(`#make-wrapper > .accordion-scroll-inner`);
  if (wrapper && $type) {
    let url = '/api/'+$type+'/manufacturers/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let modelWrapper = document.createElement("div");
        modelWrapper.classList.add('model-wrapper');
        modelWrapper.setAttribute('id', `model-wrapper--${value}`);
        modelWrapper.setAttribute('data-make', `${value}`);
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedMake = new URLSearchParams(window.location.search).get('make');
        let selectedType = new URLSearchParams(window.location.search).get('search_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'make');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        ((value == selectedMake) && ($type == selectedType)) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        wrapper.appendChild(modelWrapper);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="make"]') && document.querySelector('.search-aside input[name="make"]:checked')) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="make"]:checked').id.toUpperCase();
      }
      loadSearchTriggers();
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer, $ev_only = false) {
  // console.log('loadModels');
  if ($type && $manufacturer) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    var model_dropdowns = document.getElementsByName("model");
    for (let i = 0; i < model_dropdowns.length; i++) {
      var dropdown = model_dropdowns[i];
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      // Select the option with value equal to data-make
      let dataMake = document.querySelector('.derivative-search-bar select[name="make"]');
      if (dataMake) {
        $manufacturer = dataMake.value;
      }

      if ($manufacturer) {
        dropdown.length = 0;
        dropdown.add(loadingOption);
        dropdown.selectedIndex = 0;

        if(document.querySelector('.derivative-search-bar') && document.querySelector('body').classList.contains('theme-green')){
          $ev_only = true;
        }
        var url = $ev_only ? '/api/'+$type+'/models/'+$manufacturer+'/ev?available' : '/api/'+$type+'/models/'+$manufacturer+'/available';

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          dropdown.length = 0;
          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
          const urlParams = new URLSearchParams(window.location.search);
          const makeParam = urlParams.get('make');
          const modelParam = urlParams.get('model');
          if (modelParam && makeParam == $manufacturer) {
            dropdown.value = modelParam;
          }

          let dataModelValue = dropdown.getAttribute('data-model');
          if (dataModelValue && dataMake) {
            if(dataMake.getAttribute('data-manufacturer') == dataMake.value){
              dropdown.value = dataModelValue;
            } else {
              dropdown.selectedIndex = 0;
            }
          }
        }).catch(function(err) {
          dropdown.length = 0;
          dropdown.add(loadingError);
          dropdown.selectedIndex = 0;
          console.error('Fetch Error -', err);
        });
      }
    }
  }
}

function loadModelsRadio($type, $manufacturer) {
  const wrapper = document.querySelector(`#model-wrapper--${$manufacturer}`);
  if (wrapper && $type && $manufacturer) {

    let url = '/api/'+$type+'/models/'+$manufacturer+'/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedModel = new URLSearchParams(window.location.search).get('model');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'model');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedModel) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').id.toUpperCase();
      }
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypes($type) {
  let dropdown = document.querySelector('[name=body_type]');
  if (dropdown && $type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Bodytype';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/' + $type + '/types?available';
    url += document.querySelector('.search-form [name="make"]').value != '' ? '&make=' + document.querySelector('.search-form [name="make"]').value : '';
    if (document.querySelector('.search-form [name="model"]')) {
      url += document.querySelector('.search-form [name="model"]').value!='' ? '&model='+document.querySelector('.search-form [name="model"]').value : '';
    }

    if (document.querySelector('form.search-form')) {
      if (window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')) {
        url += '&specials=true';
      }
      if (window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')) {
        url += '&stock=true';
      }
    }


    fetch(url).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function (data) {

      dropdown.length = 0;

      var defaultOption = document.createElement('option');
      defaultOption.text = 'Any Bodytype';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      let keysSorted = Object.keys(data).sort(function (a, b) {
        return data[a].localeCompare(data[b])
      });

      const urlParams = new URLSearchParams(window.location.search);
      const body_type = urlParams.get('body_type');

      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
      if (body_type) {
        dropdown.value = body_type;
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypesRadio($type) {
  const wrapper = document.querySelector('#body_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadBodyTypesCheckbox')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedBodyType = new URLSearchParams(window.location.search).get('body_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'body_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedBodyType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
        spanName.innerText = text.replaceAll('4x4', '4x4/SUV');
        spanName.innerText = text.replaceAll('Sports', 'Convertible');
      }

      if (!searchButton) {
        if (document.querySelectorAll('.search-aside input[name="body_type"]')) {
          document.querySelectorAll('.search-aside input[name="body_type"]').forEach(v => {
            v.addEventListener('change', e => {
              setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('body_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadFuelTypesRadio($type) {
  const wrapper = document.querySelector('#fuel_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/fuel-types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
      (window.location.pathname === '/electric-leasing' || window.location.pathname === '/van-leasing/electric' || window.location.pathname === '/hybrid-leasing' || window.location.pathname === '/van-leasing/hybrid') ? wrapper.parentElement.classList.add('visuallyhidden') : wrapper.parentElement.classList.remove('visuallyhidden')
    }

    // console.log('loadFuelTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      delete data['B'];
      delete data['R'];
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]].replace(" ","-");
        let value = (keysSorted[x]=='Any') ? '' : keysSorted[x].replace(" ","-");
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedFuelType = new URLSearchParams(window.location.search).get('fuel_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'fuel_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (selectedFuelType == value) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = (keysSorted[x]=='Any') ? 'Any' : text.replace("-"," ");
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="fuel_type"]')){
          document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
            v.addEventListener('change', e => {
              setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('fuel_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadTransmissionTypesRadio($type) {
  const wrapper = document.querySelector('#transmission-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/transmissions?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadTransmissionTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      // keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]];
        let value = keysSorted[x];
        value = (value === 'Automatic') ? 'A' : (value === 'Manual') ? 'M' : (value === 'Any') ? '' : value;
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedTransmissionType = new URLSearchParams(window.location.search).get('transmission');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'transmission');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedTransmissionType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-tick');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="transmission"]')){
          document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
            v.addEventListener('change', e => {
              setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

// END SEARCH


document.addEventListener('DOMContentLoaded', () => {
    

    // Manufacturer hero image resizing, wrapped so its `return` is local
    (function initManufacturerResize() {
        const manufacturer = document.querySelector('.manufacturer');
        if (!manufacturer) return;

        const intro   = manufacturer.querySelector('.full-header-intro');
        const heroImg = manufacturer.querySelector('.hero_img img');
        if (!intro || !heroImg) return;

        const MIN_WIDTH = 1024;

        // Calculate and apply padding‑bottom (subtracting 40px)
        const updateIntroPadding = () => {
            const imgHeight = heroImg.getBoundingClientRect().height;
            const padding   = Math.max(0, imgHeight - 40);
            intro.style.paddingBottom = `${padding}px`;
        };

        // This wrapper only calls your function when <1024px,
        // and clears it when ≥1024px
        const handleResize = () => {
            if (window.innerWidth < MIN_WIDTH) {
                updateIntroPadding();
            } else {
                intro.style.paddingBottom = '';
            }
        };

        // Initial run & debounced resize
        handleResize();
        window.addEventListener('resize', debounce(handleResize, 100));
    })();


  // Deal Box Slider
  // const dealBoxSlider = [].slice.call(document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-slider'))
  // if (dealBoxSlider) {
  //   dealBoxSlider.forEach((e) => {
  //     let sliderID = e.parentElement.parentElement.getAttribute('id')
  //     new Glider(e, {
  //       slidesToScroll: 1,
  //       slidesToShow: 1,
  //       draggable: true,
  //       scrollLock: true,
  //       arrows: {
  //         prev: '.offers-strip#'+sliderID+' .glider-prev',
  //         next: '.offers-strip#'+sliderID+' .glider-next'
  //       },
  //       responsive: [
  //         {
  //           breakpoint: 767,
  //           settings: {
  //             slidesToShow: 2,
  //           }
  //         },
  //         {
  //           breakpoint: 1200,
  //           settings: {
  //             slidesToShow: 3,
  //           }
  //         }
  //       ]
  //     })
  //   })
  // }

  // Initialize Glider gallery for derivative gallery
    const track = document.querySelector('.deal-gallery-track');
    if (track) {
        new Glider(track, {
            slidesToScroll: 1,
            slidesToShow: 4,
            draggable: true,
            scrollLock: true,
            arrows: {
                prev: '.deal-gallery-controls .glider-prev',
                next: '.deal-gallery-controls .glider-next'
            }
        });
    }


  // Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount ) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function() {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

    // derivative deal-gallery thumbnail click
    document.querySelectorAll('.deal-gallery').forEach(gallery => {
        const mainImg = gallery.querySelector('.deal-gallery-img');
        const thumbs  = gallery.querySelectorAll('.gallery-thumb');

        thumbs.forEach(thumb => {
            thumb.addEventListener('click', e => {
                e.preventDefault();

                // active state
                thumbs.forEach(t => t.classList.remove('is-active'));
                thumb.classList.add('is-active');

                // pick image URL from data-img (fallback to <img> src)
                const url = thumb.dataset.img || thumb.querySelector('img')?.src;
                if (url && mainImg) mainImg.src = url;
            });
        });
    });

    // Toggle sticky only when main image + thumbs fit in the viewport
    (function initGalleryStickyToggle() {
        const galleries = document.querySelectorAll('.deal-gallery.deal-gallery--sticky');

        const fitsViewport = g => {
            const main  = g.querySelector('.deal-gallery-main');
            const track = g.querySelector('.gallery-track-ctr');
            const logo  = g.querySelector('.manufacturer-logo'); // optional
            if (!main || !track) return true;

            const hMain  = main.getBoundingClientRect().height;
            const hTrack = track.getBoundingClientRect().height;
            const hLogo  = logo ? logo.getBoundingClientRect().height : 0;

            // small buffer so a tiny overflow counts as "doesn't fit"
            return (hMain + hTrack + hLogo + 8) <= window.innerHeight;
        };

        const applyStickyState = () => {
            galleries.forEach(g => {
                const shouldStick = fitsViewport(g);
                g.classList.toggle('deal-gallery--sticky', shouldStick);
                g.classList.toggle('deal-gallery--unsticky', !shouldStick);
            });
        };

        // run now, on resize (debounced), and when images settle
        applyStickyState();
        window.addEventListener('resize', debounce(applyStickyState, 100));

        // re-check when the main image or any thumb finishes loading
        galleries.forEach(g => {
            const mainImg = g.querySelector('.deal-gallery-img');
            const thumbs  = g.querySelectorAll('.gallery-thumb img');
            const hook = img => { if (img) img.addEventListener('load', applyStickyState); };
            hook(mainImg);
            thumbs.forEach(hook);
        });
    })();





  // Google Reviews Slider
  const reviewsSlider = document.querySelector('.reviews-wrapper');
  if (reviewsSlider) {
    const glider = new Glider(reviewsSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      scrollLock: true,
      rewind: true,
      draggable: true,
      arrows: {
        prev: '.reviews .glider-prev',
        next: '.reviews .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });
    sliderAuto(glider, 8000);
  }

  

  // Hero Slider
  const heroSlider = document.querySelector('.hero-offer .full-header-feature');
  if (heroSlider) {
    const gliderHero = new Glider(heroSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.hero-offer .glider-prev',
        next: '.hero-offer .glider-next'
      }
    });
    sliderAuto(gliderHero, 8000);
  }

  // Block Slider
  const blockSlider = document.querySelector('.block-columns-puff .image-carousel');
  if (blockSlider) {
    const blockSlider1 = new Glider(blockSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      dots: '.block-columns-puff .dots'
    });
    sliderAuto(blockSlider1, 5000);
  }

  // Opening Hours Popup
  document.querySelectorAll('.opening-hours-trigger').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      alertify.alert('Opening Times')
        .setting({
          'title': `Opening Times`,
          'message': `<div class="opening-hours">${value.dataset.content}</div>`,
          'label': 'Close'
        });
    })
  });

// Toggle class for accordions
    function toggleAccordions() {
        const acc = document.getElementsByClassName('mobile-accordion-header');
        for (let i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                // close any other open accordions in this group
                for (let j = 0; j < acc.length; j++) {
                    if (acc[j] === this || acc[j].closest('.mobile-accordion') === this.closest('.mobile-accordion') || this.closest('.mobile-accordion').classList.contains('no-close')) {
                        continue;
                    }
                    acc[j].closest('.mobile-accordion').classList.remove('active');
                }

                // optional scroll
                if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')) {
                    setTimeout(() => {
                        document.documentElement.scrollTop += this.getBoundingClientRect().top;
                    }, 500);
                }
                this.parentElement.classList.toggle("active");
            });
        }
    }

    toggleAccordions();

  // FAQs Filters
  if (document.querySelector('#faq-tags-dropdown')){
    const faqCategory = (cat) => {
      if (cat === 'all') {
        document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
        document.querySelector(`.faq-tags > li > a[data-category=all]`).parentElement.classList.add('active')
        document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.remove('visuallyhidden') })
      } else {
        document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
        document.querySelector(`.faq-tags > li > a[data-category=${cat}]`).parentElement.classList.add('active')
        document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.add('visuallyhidden') })
        document.querySelectorAll(`#faq-list > div[data-category=${cat}]`).forEach(v => { v.classList.remove('visuallyhidden') })
      }
    }
    document.querySelectorAll('.faq-tags > li > a').forEach(v => {
      v.addEventListener('click', e => {
        faqCategory(e.target.dataset.category)
      })
    })
    document.querySelector('#faq-tags-dropdown').addEventListener('change', e => {
      faqCategory(e.target.options[e.target.selectedIndex].value)
    })
  }
  // END FAQs Filters

// Video Section
  let videoSections = document.querySelectorAll('.video-section');
  videoSections.forEach((section) => {
    let sectionId = section.getAttribute('data-id');
    let videoButton = document.querySelector(`#video-trigger-${sectionId}`);
    let videoWrapper = document.querySelector(`#video-vid-${sectionId}`);
    let imgWrapper = document.querySelector(`#video-img-${sectionId}`);
    let videoPopup = section.getAttribute('data-video');
    let hasPopup = section.hasAttribute('data-popup');

    if (videoButton && videoWrapper && imgWrapper) {
      videoButton.addEventListener("click", function(e) {
        if (hasPopup && videoPopup) {
          let videoModal = new tingle.modal({
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: "Close",
            cssClass: ['video-modal'],
            onClose: function() {
              this.setContent('');
            }
          });
          videoModal.setContent(`
          <div class="iframe-wrapper">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/${videoPopup}?autoplay=1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>`);
          videoModal.open();
        } else {
          let source = videoWrapper.querySelector('iframe').getAttribute('src');
          let height = imgWrapper.querySelector('img').clientHeight;
          videoWrapper.querySelector('iframe').setAttribute('src', `${source}?autoplay=1`);
          videoWrapper.style.paddingBottom = `${height}px`;
          imgWrapper.classList.add('visuallyhidden');
          videoWrapper.classList.add('active');
        }
      });
    }
  });
// END Video Section

// FAQ Search

// escape user input for RegExp
function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// safely wrap only text segments in <mark>, leave tags untouched
function safeHighlight(html, re) {
    return html.replace(/(<[^>]+>)|([^<]+)/g, (match, tag, text) => {
        if (text) {
            return text.replace(re, '<mark>$1</mark>');
        }
        return tag;
    });
}

const faqSearchBtn = document.querySelector('#faq-search-btn');
if (faqSearchBtn) {
    const closeResultsBtn = document.querySelector('#close-results-btn');

    faqSearchBtn.addEventListener('click', function(e) {
        e.preventDefault();
        // grab inputs & containers
        const searchField = document.querySelector('#faq-search');
        const query       = searchField.value.trim();
        const noResults   = document.querySelector('#no-results');
        const resultList  = document.querySelector('#search-results');
        const wrapper     = document.querySelector('.search-results');

        console.log("searchField " + searchField);
        console.log("query  " + query );
        console.log("noResults  " + noResults );
        console.log("resultList " + resultList);
        console.log("wrapper " + wrapper);



        // clear previous results
        resultList.innerHTML = '';
        noResults.classList.add('visuallyhidden');

        // collect only the ORIGINAL FAQ items (not clones)
        const allFaqs = Array
            .from(document.querySelectorAll('.faq.mobile-accordion'))
            .filter(item => !item.closest('.search-results'));

        console.log(allFaqs);
        // **1. enforce minimum length (2 chars)**
        if (query.length < 2) {
            // you could show a “type 2+ chars” message here if you like
            noResults.classList.remove('visuallyhidden');
            wrapper.classList.add('active');
            return;
        }

        // **2a. whole-word match** (uncomment if you want only full-word searches)
        //const re = new RegExp('\\b(' + escapeRegExp(query) + ')\\b', 'gi');

        // **2b. partial-word match** (uncomment instead if you want ANY substring,
        // but still require 2+ chars)
        const re = new RegExp('(' + escapeRegExp(query) + ')', 'gi');

        let matches = 0;

        allFaqs.forEach(item => {
            // use our regex test rather than simple includes()
            if (re.test(item.textContent)) {
                const clone = item.cloneNode(true);
                // wrap only the matched text nodes
                clone.innerHTML = safeHighlight(clone.innerHTML, re);
                resultList.append(clone);
                matches++;
                console.log("match" + matches);
            }
        });

        // restore accordion toggles inside results
        toggleAccordions();

        if (matches == 0) {
            console.log("matches" + matches);
            noResults.classList.remove('visuallyhidden');
        }
        wrapper.classList.add('active');
        console.log("end" + matches);
    });

    if (closeResultsBtn) {
        closeResultsBtn.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelector('.search-results')
                    .classList.remove('active');
            toggleAccordions();
        });
    }
}
// END FAQ Search


// Search popular FAQs
(function () {
    const input = document.getElementById('faq-search');
    const btn   = document.getElementById('faq-search-btn');

    if (!input || !btn) return;

    // 1) Click a popular chip → fill input → run existing search
    document.addEventListener('click', function (e) {
      const chip = e.target.closest('.js-faq-chip');
      if (!chip) return;

      e.preventDefault();
      const q = chip.dataset.query || chip.textContent.trim();
      input.value = q;
      input.focus();

      // fire your current search handler
      btn.click();
    }, false);

    // 2) Optional: if we landed on ?search=… (no-JS fallback), auto-run search on load
    try {
      const url = new URL(window.location);
      const q = url.searchParams.get('search');
      if (q && q.trim().length) {
          input.value = q.trim();
          btn.click();
      }
    } catch (_) { /* ignore */ }
})();



  // Wrap editor table in div for responsiveness
  const editorAreas = document.querySelectorAll('.editor');

  editorAreas.forEach(editor => {
    const tables = editor.querySelectorAll('table');

    tables.forEach(table => {
      // Avoid wrapping it again if already inside a .table-wrapper
      if (!table.parentElement || !table.parentElement.classList.contains('table-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('table-wrapper');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });
  });


    // Add To Compare - Car
    document.querySelectorAll('button[data-compare][data-type="car"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            const btn = e.currentTarget;
            let cookie = Cookies.get('compare_list')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[btn.dataset.compare] === undefined) {
                    if (Object.keys(cookie_obj).length < 3) {
                        cookie_obj = {...cookie_obj, [btn.dataset.compare] : btn.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('compare_list', cookie_string)
                        btn.classList.add('active');
                        btn.dataset.compareAdded = 'true';
                        alertify.confirm('Car Comparison')
                            .setting({
                                'title': 'Car Comparison',
                                'message': `
                      <span class="semi-bold">${btn.dataset.name}</span> added to comparison
                      ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                        <br><br> <span class="semi-bold">You are comparing:</span>
                        <ul>
                          <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                          ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                          ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                        </ul>
                      ` : ''}
                    `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/car-comparison" },
                                'onclose': comparisonCount
                            });
                    } else {
                        alertify.confirm('Car Comparison')
                            .setting({
                                'title': 'Car Comparison',
                                'message': `
                      <span class="semi-bold">Car comparison full.</span>
                      <br><br>
                      <span>If you wish to continue remove one of the items below and add ${btn.dataset.name} again.</span>
                      <br><br> <span class="semi-bold">You are comparing:</span>
                      <ul>
                        <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                        <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                        <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      </ul>
                    `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/car-comparison" },
                                'onclose': comparisonCount
                            });
                    }
                } else {
                    delete cookie_obj[btn.dataset.compare];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
                    btn.classList.remove('active');
                    btn.dataset.compareAdded = 'false';
                    alertify.confirm('Car Comparison')
                        .setting({
                            'title': 'Car Comparison',
                            'message': `<span class="semi-bold">${btn.dataset.name}</span> removed from comparison`,
                            'labels': { ok: 'Go To Compare', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/car-comparison" },
                            'onclose': comparisonCount
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${btn.dataset.compare}":"${btn.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list', cookie_string)
                btn.classList.add('active');
                btn.dataset.compareAdded = 'true';

                alertify.confirm('Car Comparison')
                    .setting({
                        'title': 'Car Comparison',
                        'message': `<span class="semi-bold">${btn.dataset.name}</span> added to comparison`,
                        'labels': { ok: 'Go To Compare', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/car-comparison" },
                        'onclose': comparisonCount
                    });
            }
        })
    })
    // Add To Compare - Van
    document.querySelectorAll('button[data-compare][data-type="van"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            const btn = e.currentTarget;
            let cookie = Cookies.get('compare_list_vans')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[btn.dataset.compare] === undefined) {
                    if (Object.keys(cookie_obj).length < 3) {
                        cookie_obj = {...cookie_obj, [btn.dataset.compare] : btn.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('compare_list_vans', cookie_string)
                        btn.classList.add('active');
                        btn.dataset.compareAdded = 'true';
                        alertify.confirm('Van Comparison')
                            .setting({
                                'title': 'Van Comparison',
                                'message': `
                      <span class="semi-bold">${btn.dataset.name}</span> added to comparison
                      ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                        <br><br> <span class="semi-bold">You are comparing:</span>
                        <ul>
                          <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                          ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                          ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                        </ul>
                      ` : ''}
                    `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/van-comparison" },
                                'onclose': comparisonCount
                            });
                    } else {
                        alertify.confirm('Car Comparison')
                            .setting({
                                'title': 'Van Comparison',
                                'message': `
                      <span class="semi-bold">Van comparison full.</span>
                      <br><br>
                      <span>If you wish to continue remove one of the items below and add ${btn.dataset.name} again.</span>
                      <br><br> <span class="semi-bold">You are comparing:</span>
                      <ul>
                        <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                        <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                        <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/crusader/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      </ul>
                    `,
                                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/van-comparison" },
                                'onclose': comparisonCount
                            });
                    }
                } else {
                    delete cookie_obj[btn.dataset.compare];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
                    btn.classList.remove('active');
                    btn.dataset.compareAdded = 'false';
                    alertify.confirm('Van Comparison')
                        .setting({
                            'title': 'Van Comparison',
                            'message': `<span class="semi-bold">${btn.dataset.name}</span> removed from comparison`,
                            'labels': { ok: 'Go To Compare', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/van-comparison" },
                            'onclose': comparisonCount
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${btn.dataset.compare}":"${btn.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list_vans', cookie_string)
                btn.classList.add('active');
                btn.dataset.compareAdded = 'true';

                alertify.confirm('Van Comparison')
                    .setting({
                        'title': 'Van Comparison',
                        'message': `<span class="semi-bold">${btn.dataset.name}</span> added to comparison`,
                        'labels': { ok: 'Go To Compare', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/van-comparison" },
                        'onclose': comparisonCount
                    });
            }
        })
    })

     // Add To Favourites - Car
    document.querySelectorAll('button[data-favourite][data-type="car"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            let cookie = Cookies.get('favourite_list')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[e.currentTarget.dataset.favourite] === undefined) {
                    if (Object.keys(cookie_obj).length < 30) {
                        cookie_obj = {...cookie_obj, [e.currentTarget.dataset.favourite] : e.currentTarget.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('favourite_list', cookie_string)
                        e.currentTarget.classList.add('active');
                        e.currentTarget.dataset.favouriteAdded = 'true';
                        alertify.confirm('Your Favourites')
                            .setting({
                                'title': 'Your Favourites',
                                'message': `
                      <span class="semi-bold">${e.currentTarget.dataset.name}</span> added to favourites
                    `,
                                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/favourites" }
                            });
                    } else {
                        alertify.confirm('Your Favourites')
                            .setting({
                                'title': 'Your Favourites',
                                'message': `
                      <span class="semi-bold">Favourites list full.</span>
                      <br><br>
                      <span>If you wish to continue remove one of the items on your favourites list add ${e.currentTarget.dataset.name} again.</span>
                    `,
                                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/favourites" }
                            });
                    }
                } else {
                    delete cookie_obj[e.currentTarget.dataset.favourite];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list');
                    e.currentTarget.classList.remove('active');
                    e.currentTarget.dataset.favouriteAdded = 'false';
                    document.querySelector('.tools-main>.favourites') ? e.currentTarget.closest('.deal-box').remove() : null;
                    alertify.confirm('Your Favourites')
                        .setting({
                            'title': 'Your Favourites',
                            'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> removed from favourites`,
                            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/favourites" }
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${e.currentTarget.dataset.favourite}":"${e.currentTarget.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('favourite_list', cookie_string)
                e.currentTarget.classList.add('active');
                e.currentTarget.dataset.favouriteAdded = 'true';
                alertify.confirm('Your Favourites')
                    .setting({
                        'title': 'Your Favourites',
                        'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> added to favourites`,
                        'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/favourites" }
                    });
            }
        })
    })

    // Add To Favourites - Van
    document.querySelectorAll('button[data-favourite][data-type="van"]').forEach((value) => {
        value.addEventListener('click', (e) => {
            e.preventDefault();
            let cookie = Cookies.get('favourite_list_vans')
            if (cookie) {
                let cookie_obj = JSON.parse(cookie);
                if (cookie_obj[e.currentTarget.dataset.favourite] === undefined) {
                    if (Object.keys(cookie_obj).length < 30) {
                        cookie_obj = {...cookie_obj, [e.currentTarget.dataset.favourite] : e.currentTarget.dataset.name};
                        let cookie_string = JSON.stringify(cookie_obj)
                        Cookies.set('favourite_list_vans', cookie_string)
                        e.currentTarget.classList.add('active');
                        e.currentTarget.dataset.favouriteAdded = 'true';
                        alertify.confirm('Your Favourites')
                            .setting({
                                'title': 'Your Favourites',
                                'message': `
                      <span class="semi-bold">${e.currentTarget.dataset.name}</span> added to favourites
                    `,
                                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/favourites" }
                            });
                    } else {
                        alertify.confirm('Your Favourites')
                            .setting({
                                'title': 'Your Favourites',
                                'message': `
                      <span class="semi-bold">Favourites list full.</span>
                      <br><br>
                      <span>If you wish to continue remove one of the items on your favourites list add ${e.currentTarget.dataset.name} again.</span>
                    `,
                                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                                'onok': function(){ window.location.href = "/favourites" }
                            });
                    }
                } else {
                    delete cookie_obj[e.currentTarget.dataset.favourite];
                    (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list_vans');
                    e.currentTarget.classList.remove('active');
                    e.currentTarget.dataset.favouriteAdded = 'false';
                    document.querySelector('.tools-main>.favourites') ? e.currentTarget.closest('.deal-box').remove() : null;
                    alertify.confirm('Your Favourites')
                        .setting({
                            'title': 'Your Favourites',
                            'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> removed from favourites`,
                            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                            'onok': function(){ window.location.href = "/favourites" }
                        });
                }
            } else {
                let cookie_obj = JSON.parse(`{"${e.currentTarget.dataset.favourite}":"${e.currentTarget.dataset.name}"}`);
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('favourite_list_vans', cookie_string)
                e.currentTarget.classList.add('active');
                e.currentTarget.dataset.favouriteAdded = 'true';
                alertify.confirm('Your Favourites')
                    .setting({
                        'title': 'Your Favourites',
                        'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> added to favourites`,
                        'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                        'onok': function(){ window.location.href = "/favourites" }
                    });
            }
        })
    })


  // Compare Count
  function comparisonCount() {
    let car_count = 0;
    let cookie = Cookies.get('compare_list')
    if (Cookies.get('compare_list')) {
      let cookie_obj = JSON.parse(cookie);
      car_count = Object.keys(cookie_obj).length;
    }
    document.querySelectorAll('.comparison_counter').forEach(v => { v.innerText = car_count });
    let van_count = 0;
    let van_cookie = Cookies.get('compare_list_vans')
    if (Cookies.get('compare_list_vans')) {
      let van_cookie_obj = JSON.parse(van_cookie);
      van_count = Object.keys(van_cookie_obj).length;
    }
    document.querySelectorAll('.comparison_counter_van').forEach(v => { v.innerText = van_count });
  }
  comparisonCount();
  document.querySelectorAll('div[data-car] .reset, .alertify .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })
  let derivativeField = document.querySelector('#car-comparison select[name=calculator-derivative]');
  if (derivativeField) {
    derivativeField.addEventListener('change', (event) => {
      comparisonCount();
    })
  }
  document.querySelectorAll('div[data-car] .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })

  // Share Button
  document.querySelectorAll('button.share-button').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      alertify.alert('Share')
        .setting({
          'title': `Share ${e.target.dataset.car}`,
          'message': `
                <p class="share-button">
                  <a class="share-facebook" href="https://www.facebook.com/sharer/sharer.php?u=${e.target.dataset.url}" title="Share by Facebook" target="_blank">
                      <svg id="_01.facebook" data-name="01.facebook" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <ellipse id="Ellipse_4401" data-name="Ellipse 4401" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(0.524 1.451)" fill="#fff"/>
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Zm3.748,13.388-.245,2.061a.389.389,0,0,1-.389.346h-2.14V21.9a.276.276,0,0,1-.272.278H13.31a.276.276,0,0,1-.272-.28l.012-6.108H11.428a.389.389,0,0,1-.389-.389V13.347a.389.389,0,0,1,.389-.389h1.609v-2a3.213,3.213,0,0,1,3.386-3.567h1.648a.389.389,0,0,1,.389.389V9.517a.389.389,0,0,1-.389.389h-1.01c-1.094.018-1.3.541-1.3,1.323v1.722h2.4a.389.389,0,0,1,.378.436Z" fill="#405a9a"/>
                      </svg>
                      &nbsp;Share by Facebook
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-twitter" href="https://twitter.com/intent/tweet?text=${e.target.dataset.url}" title="Share by Twitter" target="_blank">
                      <svg id="Group_1789" data-name="Group 1789" xmlns="http://www.w3.org/2000/svg" width="29.535" height="29.535" viewBox="0 0 29.535 29.535">
                        <circle id="Ellipse_4400" data-name="Ellipse 4400" cx="13.5" cy="13.5" r="13.5" transform="translate(0.956 1.089)" fill="#fff"/>
                        <path id="Path_609" data-name="Path 609" d="M14.767,0A14.767,14.767,0,1,0,29.535,14.767,14.767,14.767,0,0,0,14.767,0Zm7.355,10.3a6.235,6.235,0,0,1-1.265,1.389.54.54,0,0,0-.194.422v.049a8.856,8.856,0,0,1-.571,3.082,9.026,9.026,0,0,1-1.681,2.817,8.3,8.3,0,0,1-3.643,2.407,9.113,9.113,0,0,1-2.864.445,8.743,8.743,0,0,1-4.39-1.183.253.253,0,0,1-.121-.28.243.243,0,0,1,.237-.183H8a5.889,5.889,0,0,0,3.292-1,3.2,3.2,0,0,1-2.526-2.17.167.167,0,0,1,.194-.216,2.93,2.93,0,0,0,.536.051h.068A3.191,3.191,0,0,1,7.7,12.993a.167.167,0,0,1,.247-.146,2.806,2.806,0,0,0,.727.282,3.191,3.191,0,0,1-.515-3.869.167.167,0,0,1,.274-.021A8.355,8.355,0,0,0,14.169,12.3h.016a.12.12,0,0,0,.117-.13,3.379,3.379,0,0,1,.074-1.166,3.091,3.091,0,0,1,2.079-2.223,3.418,3.418,0,0,1,1.008-.155,3.179,3.179,0,0,1,2.106.795.412.412,0,0,0,.274.1.418.418,0,0,0,.1-.014,5.888,5.888,0,0,0,1.554-.641.165.165,0,0,1,.243.194A3.154,3.154,0,0,1,20.9,10.4a5.709,5.709,0,0,0,1.018-.344.167.167,0,0,1,.2.239Z" fill="#64adf0"/>
                      </svg>
                      &nbsp;Share by Twitter
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-linkedin" href="https://www.linkedin.com/shareArticle?mini=true&url=${e.target.dataset.url}" title="Share by LinkedIn" target="_blank">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
                          <g id="Layer_1-2"><path d="m542.45,1075.59C248.67,1076.4,5.67,837.06,7,537.78,8.31,242,250.29,1.17,549.67,5.11c293.69,3.86,530.16,244.44,527.95,539.4-2.21,294.77-242.66,531.68-535.17,531.08Zm54.06-279.84v-6.2c0-66.8,0-133.6,0-200.41,0-3,.05-6,.11-8.99.42-21.18,9.69-38.17,25.37-51.72,15.66-13.53,34.22-17.08,54.27-13.95,18.91,2.95,32.2,13.53,40.36,30.67,1.64,3.44,2.99,7.05,4.18,10.68,4.25,12.96,5.56,26.38,5.58,39.9.09,64.8.04,129.61.05,194.41,0,1.92.09,3.84.13,5.58h123.27c0-2.31,0-4.28,0-6.25,0-66.3.06-132.61-.05-198.91-.02-11.48-.35-22.99-1.21-34.43-1.56-20.7-6.03-40.83-14.23-59.97-15.77-36.82-42.18-62.19-80.89-73.85-20.33-6.12-41.16-7.67-62.28-5.54-20.74,2.09-40,8.3-57.29,20.16-13.51,9.27-24.32,21.16-33.63,34.53-.96,1.38-1.6,3.12-3.74,4.19v-17.46c0-5.5.01-10.99,0-16.49-.02-5.59-.06-11.18-.09-16.69-12.71-1.03-119.67-.55-123.31.49,1.36,123.36.08,246.72-.25,370.25h123.65Zm-315.51-370.77c0,122.7,0,244.9,0,367.09,0,.99.12,1.98.21,2.96.01.15.16.29.27.41.1.12.24.21.71.62,38.76,0,77.87,0,116.99-.01,1.49,0,2.98-.15,4.46-.24.15,0,.31-.1.43-.21.12-.11.19-.27.36-.53v-370.1h-123.45Zm62.76-179.65c-5.29.54-10.63.75-15.85,1.68-35.41,6.29-54.7,33.52-54.14,64.01.48,26.14,15.67,48.46,40.02,57.9,13.05,5.06,26.54,5.85,40.28,4.35,7.31-.8,14.38-2.68,21.13-5.61,27.68-11.99,42.46-41.06,36.07-70.92-4.61-21.57-16.92-36.9-37.26-45.53-9.62-4.08-19.78-5.67-30.25-5.89Z" fill="#005983"/></g>
                      </svg>
                      &nbsp;Share by LinkedIn
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-whatsapp" href="whatsapp://send?text=I'd like to share a link with you: ${e.target.dataset.url}" data-action="share/whatsapp/share" title="Share by WhatsApp" target="_blank">
                        <svg id="_08.whatsapp" data-name="08.whatsapp" xmlns="http://www.w3.org/2000/svg" width="29.646" height="29.646" viewBox="0 0 29.646 29.646">
                          <ellipse id="Ellipse_4398" data-name="Ellipse 4398" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(1.293 1.52)" fill="#fff"/>
                          <path id="Path_611" data-name="Path 611" d="M56.371,47.966l-.029-.029a5.756,5.756,0,0,0-9.2,6.676l.254.5-.474,2.3v.029L49.2,56.9l.519.257a5.75,5.75,0,0,0,6.651-9.19Zm-.23,6.436a2.4,2.4,0,0,1-1.274,1.11c-.975.236-2.459,0-4.318-1.718l-.023-.021c-1.617-1.51-2.046-2.768-1.95-3.764A2.387,2.387,0,0,1,49.5,48.6a.529.529,0,0,1,.829.2l.6,1.365a.527.527,0,0,1-.064.538l-.3.39a.517.517,0,0,0-.041.575A5.656,5.656,0,0,0,51.547,52.8a5.967,5.967,0,0,0,1.424,1.02.515.515,0,0,0,.564-.119l.349-.353a.53.53,0,0,1,.536-.164l1.424.41a.532.532,0,0,1,.3.8Z" transform="translate(-37.452 -37.239)" fill="#4cd360"/>
                          <path id="Path_612" data-name="Path 612" d="M14.823,0A14.823,14.823,0,1,0,29.646,14.823,14.823,14.823,0,0,0,14.823,0ZM22.17,15a7.355,7.355,0,0,1-10.622,6.348l-3.706.882a.287.287,0,0,1-.3-.117.281.281,0,0,1-.045-.22l.78-3.788a7.353,7.353,0,1,1,13.9-3.1Z" fill="#4cd360"/>
                        </svg>
                      &nbsp;Share by WhatsApp
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-mail" href="mailto:?subject=I'd like to share a link with you&amp;body=${e.target.dataset.url}" title="Share by Email" target="_blank">
                      <svg id="_01.email" data-name="01.email" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Z" fill="#18235b"/>
                        <g id="email_1_" data-name="email (1)" transform="translate(7.73 9.534)">
                          <g id="Group_6951" data-name="Group 6951" transform="translate(0 2.915)">
                            <g id="Group_6950" data-name="Group 6950">
                              <path id="Path_10117" data-name="Path 10117" d="M7.419,151.224a.8.8,0,0,1-.828,0L0,147.2v5.349a2.071,2.071,0,0,0,2.07,2.07h9.887a2.071,2.071,0,0,0,2.07-2.07V147.2Z" transform="translate(0 -147.2)" fill="#fff"/>
                            </g>
                          </g>
                          <g id="Group_6953" data-name="Group 6953" transform="translate(0.066)">
                            <g id="Group_6952" data-name="Group 6952" transform="translate(0 0)">
                              <path id="Path_10118" data-name="Path 10118" d="M13.938,57.088H4.052a2.058,2.058,0,0,0-2,1.623L9,62.95l6.939-4.239A2.058,2.058,0,0,0,13.938,57.088Z" transform="translate(-2.048 -57.088)" fill="#fff"/>
                            </g>
                          </g>
                        </g>
                      </svg>
                      &nbsp;Share by Email
                  </a>
                </p>`,
          'label': 'Close'
        });
    })
  })


// Charging Speeds
if (document.querySelector('#charging-speeds')) {
  function isElementVisible(el) {
    let rect    = el.getBoundingClientRect(),
        vW      = window.innerWidth || document.documentElement.clientWidth,
        vH      = window.innerHeight || document.documentElement.clientHeight,
        efp     = (x, y) => document.elementFromPoint(x, y);

    if (rect.right < 0 || rect.bottom < 0 || rect.left > vW || rect.top > vH)
      return false;

    return (
      el.contains(efp(rect.left,  rect.top))    ||
      el.contains(efp(rect.right, rect.top))    ||
      el.contains(efp(rect.right, rect.bottom)) ||
      el.contains(efp(rect.left,  rect.bottom))
    );
  }

  function scrollAnimTriggerCheck() {
    console.log('scrollAnimTriggerCheck running');
    const legend = document.querySelector('#charging-speeds .deal-charging-legend');
    if (!legend || !isElementVisible(legend)) return;

    // grab your speeds
    const homeEl  = document.getElementById('progress_bar_home'),
          fastEl  = document.getElementById('progress_bar_fast'),
          rapidEl = document.getElementById('progress_bar_rapid'),
          ultraEl = document.getElementById('progress_bar_ultra');

    const speedHome  = parseInt(homeEl .dataset.speed, 10),
          speedFast  = parseInt(fastEl .dataset.speed, 10),
          speedRapid = parseInt(rapidEl.dataset.speed, 10),
          speedUltra = parseInt(ultraEl.dataset.speed, 10);

    // compute each width against "home"
    const wHome  = (speedHome  / speedHome ) * 100, // =100
          wFast  = (speedFast  / speedHome ) * 100,
          wRapid = (speedRapid / speedHome ) * 100,
          wUltra = (speedUltra / speedHome ) * 100;

    // write into --progress on each element
    homeEl .style.setProperty('--progress', wHome );
    fastEl .style.setProperty('--progress', wFast );
    rapidEl.style.setProperty('--progress', wRapid);
    ultraEl.style.setProperty('--progress', wUltra);

    // clean up so it only runs once
    document.removeEventListener('scroll', scrollAnimTriggerCheck);
    document.removeEventListener('DOMContentLoaded', scrollAnimTriggerCheck);
  }

  // fire on load and on scroll (so it’ll catch you even if you never scroll)
  document.addEventListener('DOMContentLoaded', scrollAnimTriggerCheck);
  document.addEventListener('scroll',              scrollAnimTriggerCheck);
}



  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    hamburger.classList.remove('active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
  }, false);

  const showDescription = document.getElementById('show-description');
  if (showDescription) {
    (document.querySelector('.manufacturer-header-description >*:nth-of-type(2)')) ? showDescription.classList.remove('visuallyhidden') : null;
    showDescription.addEventListener('click', (e) => {
      e.target.parentElement.classList.add('full-description');
    })
  }

  const showFullTable = document.getElementById('show-all-rows');
  if (showFullTable) {
    showFullTable.addEventListener('click', (e) => {
      document.querySelector('#model-table .model-table-body').classList.add('model-table-body--full');
      showFullTable.classList.add('visuallyhidden');
    })
  }

  const showFullSpec = document.getElementById('show-all-spec');
  if (showFullSpec) {
    showFullSpec.addEventListener('click', (e) => {
      document.querySelector('.deal-tabs').classList.remove('hidden');
      showFullSpec.classList.add('visuallyhidden');
    })
  }

  // Model Table Sorting
  function sortTable(elem, type) {
    let tableBody = document.querySelector('#model-table .model-table-body');
    let tableRows = Array.from(tableBody.children);
    let sortName;
    let sortDirection;
    if (type === 'default') {
      sortName = 'price';
      sortDirection = 'desc';
      document.querySelector('#sortSelect').selectedIndex = '0';
    } else {
      sortName = (type !== 'dropdown') ? elem.composedPath()[0].dataset.sortname : elem.options[elem.selectedIndex].dataset.sortname;
      sortDirection = (type !== 'dropdown') ? elem.composedPath()[0].dataset.sortdirection : elem.options[elem.selectedIndex].dataset.sortdirection;
    }

    tableRows.forEach(value => {value.classList.remove('no-price')});

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      if (sortName === 'price') {
        return (dir === 'asc') ? b.localeCompare(a, 'en', {numeric: true}) : a.localeCompare(b, 'en', {numeric: true});
      }
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      if (type === 'default') {
        elem.setAttribute('data-sortdirection', 'desc')
      } else {
        (type !== 'dropdown') ? elem.composedPath()[0].setAttribute('data-sortdirection', 'desc') : null;
      }
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      if (type === 'default') {
        elem.setAttribute('data-sortdirection', 'asc')
      } else {
        (type !== 'dropdown') ? elem.composedPath()[0].setAttribute('data-sortdirection', 'asc') : null;
      }
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }
  // Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val, 'buttons')));
  let sortDropdown = document.querySelector('#model-table .model-table-head #sortSelect');
  (sortDropdown) ? sortDropdown.addEventListener('change', (e) => sortTable(e.target, 'dropdown')) : null;
  // END Model Table Sorting


  // Initialize GLightbox
  if(document.querySelector('.glightbox-gallery')){
    const lightbox = GLightbox({
      selector: '.glightbox'
    });

    // Handle "View Full Gallery" thumbnail click
    if(document.querySelector('.gallery-item.view-full')){
      document.querySelector('.gallery-item.view-full').onclick = function() {
        // Programmatically open the lightbox starting from the first image
        lightbox.open();
      }
    }
  }



  if(document.querySelector('.deal-gallery .swiper-container-wrapper')){
    const galleryThumbs = new Swiper(".gallery-thumbs", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      direction: "horizontal",
      spaceBetween: 5,
      slidesPerView: 3,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        481: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        769: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1441: {
          centeredSlides: true,
          slidesPerView: 5,
          spaceBetween: 15,
          direction: "vertical",
        },
      },
    });

    const galleryTop = new Swiper(".gallery-top", {
      direction: "horizontal",
      spaceBetween: 5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });

    galleryTop.on("slideChangeTransitionStart", function () {
      galleryThumbs.slideTo(galleryTop.activeIndex);
    });

    galleryThumbs.on("transitionStart", function () {
      galleryTop.slideTo(galleryThumbs.activeIndex);
    });
  }

  // Video Modal
  if(document.querySelector('a#review_video')) {
    const video_popup = document.querySelector('a#review_video').dataset.video;
    const videoModal = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: ['video-modal'],
      onClose: function() {
        this.setContent('');
      }
    });
    document.querySelector('a#review_video').addEventListener("click", function(e){
      e.preventDefault();
      videoModal.setContent(`
          <div class="iframe-wrapper">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/${video_popup}?autoplay=1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>`);
      videoModal.open();
    })
  }
  // END Video Modal

  // Load Search Form
  function loadSearchForm () {
    // Load Search Form
    if(document.getElementsByClassName('search-form').length>0){
      updateSearchToggles();
      loadSearchTriggers();
      // Search
      let searchType = document.querySelector('#search-type') ? document.querySelector('#search-type').value : 'van';
      if (document.querySelector('#search-bar')) {
        loadManufacturers(searchType);
        loadBodyTypes(searchType);
      } else {
        // loadManufacturersRadio(searchType);
        loadBodyTypesRadio(searchType);
      }
      document.querySelectorAll('.search-form [name=search-type]').forEach(v => { v.addEventListener("change", function(e){
        if (document.querySelector('#search-bar')) {
          loadManufacturers(searchType, e.target.value);
        } else {
          loadManufacturersRadio(searchType, e.target.value);
          loadBodyTypesRadio(searchType, e.target.value);
        }
      })
      });

      document.querySelectorAll('.search-form [name=make]').forEach(v => { v.addEventListener("change", function(e){
        if (document.querySelector('#search-bar')) {
          if (document.querySelector('[name="fuel_type"]')) {
            loadModels(searchType, e.target.value, true);
          } else {
            loadModels(searchType, e.target.value);
          }
        } else {
          loadModelsRadio(searchType, e.target.value);
        }
      })
      });
    }
  }
  
  if (used_ev == false) {
    loadSearchForm();
  } else {
    updateSearchToggles();
    loadSearchTriggers();
    loadBodyTypes('car');
    loadBodyTypesRadio('car');
  }

  // END Load Search Form

  // Search Sidebar Toggle
  let sidebarToggle = document.querySelector('#search-filters-toggle');
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', (e) => {
      if (!sidebarToggle.parentElement.classList.contains('active')) {
        setTimeout(() => {
          document.querySelector('body').scrollIntoView();
          console.log(document.querySelector('#search-filters-toggle').parentElement.parentElement)
        }, 500);
        // document.querySelector('.search-content').style.minHeight = `${(document.querySelector('.search-results-form').clientHeight) * 2}px`;
      } else {
        e.preventDefault();
        // document.querySelector('.search-content').style.minHeight = `100px`;
      }
      sidebarToggle.parentElement.classList.toggle('active');
      sidebarToggle.blur();
      sidebarToggle.parentElement.focus();
    })
  }
  // END Search Sidebar Toggle

  // Search Mobile Popup
  const filterButton = document.querySelector('.search-filters-mobile .vehicle-filters');
  const termsButton = document.querySelector('.search-filters-mobile .vehicle-terms');
  let searchSidebar = document.querySelector('.search-aside');
  let searchTerms = document.querySelector('.search-filters');
  // const updateMobileResultsBtn = document.querySelector('.update-mobile-results');
  let modelSelected = 0;
  let specSelected = 0;

  if(filterButton && searchSidebar){
    const modalMobileFilters = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchSidebar ? modalMobileFilters.setContent(searchSidebar.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        let searchAside = document.querySelector('.search-content .search-aside');
        searchAside.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        // loadUrlParams();
        // resetSearch()
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        filterButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-aside');
        document.querySelector('.search-content').prepend(searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        // loadUrlParams();
        // resetSearch()
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    filterButton.addEventListener("click", function(e){
      filterButton.parentElement.classList.toggle('is-active');
      if(filterButton.parentElement.classList.contains("is-active")) {
        modalMobileFilters.open();
      } else{
        modalMobileFilters.close();
      }
    })
  }
  if(termsButton && searchTerms){
    const modalMobileTerms = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar-terms'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchTerms ? modalMobileTerms.setContent(searchTerms.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        searchTerms = document.querySelector('.search-filters');
        searchTerms.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        // loadUrlParams();
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
        // resetSearch()
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        termsButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-filters');
        document.querySelector('.deal-list.deal-boxes').insertAdjacentElement('beforebegin', searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        // loadUrlParams();
        // updateMobileResults();
        // resetSearch()
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    termsButton.addEventListener("click", function(e){
      termsButton.parentElement.classList.toggle('is-active');
      if(termsButton.parentElement.classList.contains("is-active")) {
        modalMobileTerms.open();
      } else{
        modalMobileTerms.close();
      }
    })
  }
  // END Search Mobile Popup

});


function debounce(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}


// Custom Carousel - requires function debounce

class Carousel {
    constructor(selector, options = {}) {
        this.container = document.querySelector(selector);
        if (!this.container) throw new Error(`Element ${selector} not found`);

        this.defaultVisibleItems = options.visibleItems || 2;
        this.visibleItems = this.defaultVisibleItems;
        this.breakpoints = options.breakpoints || {};
        this.disabledBreakpoints = options.disabledBreakpoints || [];
        this.interval = options.interval || 3000;
        this.transitionDuration = options.transitionDuration || 300;
        this.enableArrows = options.enableArrows || false;
        this.enableJumpLinks = options.enableJumpLinks || false;
        this.customLinksSelector = options.customLinksSelector || null;
        this.infinite = (options.infinite !== undefined) ? options.infinite : true;

        // Default values for peek/gap/offset if none provided
        this.peek = options.peek || '0px';
        this.gap = options.gap || '0px';
        this.offset = options.offset || '0px';

        // Responsive layout object for visibleItems, peek, gap, offset
        this.responsiveLayout = options.responsiveLayout || {};

        this.autoSlide = (options.autoSlide !== undefined) ? options.autoSlide : true;

        // Option to enable or disable reduced opacity
        this.reduceOpacity = options.reduceOpacity || true;

        // Hide the first cloned item while preserving space
        this.hideFirstClone = options.hideFirstClone || false;

        // Arrow placement
        this.arrowPlacement = options.arrowPlacement || 'inside';

        this.customLinks = [];

        this.prevArrow = null;
        this.nextArrow = null;

        this.wrapper = this.container.firstElementChild;
        this.items = Array.from(this.wrapper.children);
        this.totalItems = this.items.length;
        this.currentIndex = 0;
        this.isEnabled = true;
        this.intervalId = null;

        this.isSwiping = false;
        this.startX = 0;
        this.threshold = 0;
        this.itemWidth = 0;
        this.gapPx = 0;
        this.offsetPx = 0;

        this.init();
        window.addEventListener('resize', debounce(() => this.handleResize(), 200));
    }


    init() {
        this.updateEnabledState();

        const { chosenVisibleItems, chosenPeek, chosenGap, chosenOffset } = this.determineResponsiveValues();
        this.visibleItems = chosenVisibleItems;

        this.updateColumnClass();
        this.wrapper.style.setProperty('--peek', this.ensureUnit(chosenPeek));
        this.wrapper.style.setProperty('--gap', this.ensureUnit(chosenGap));

        if (this.isEnabled && this.infinite) {
            this.addClones();
            // Start from index 1, so the second slide is “center”
            this.currentIndex = 1;
        }

        // Always add arrows if enabled
        if (this.enableArrows) {
            this.addArrows(); 
        }

        // Always create jump links if enabled, regardless of enabled state
        if (this.enableJumpLinks) {
            this.createJumpLinks();
        }

        // If customLinksSelector provided, attach them
        if (this.customLinksSelector) {
            this.attachCustomLinks();
        }

        // Add interaction events once
        this.addInteractionEvents();

        requestAnimationFrame(() => {
            this.itemWidth = this.items[0].getBoundingClientRect().width;
            this.gapPx = this.convertToPx(chosenGap);
            this.offsetPx = this.convertToPx(chosenOffset);
            this.threshold = this.itemWidth * 0.2;

            if (this.enableArrows) {
                this.updateArrowVisibility();
            }

            if (this.isEnabled) {
                if (this.autoSlide && this.shouldSlide()) {
                    this.startAutoSlide();
                }

                this.preloadImages && this.preloadImages();
            }

            const stepSize = this.itemWidth + this.gapPx;
            const initialTransformValue = this.offsetPx - (this.currentIndex * stepSize);
            this.wrapper.style.transform = `translateX(${initialTransformValue}px)`;


            this.updateItemOpacity && this.updateItemOpacity(); // Update Opacity
        });
    }

    handleResize() {
        // Re-check enabled state on every resize
        this.updateEnabledState();

        const { chosenVisibleItems, chosenPeek, chosenGap, chosenOffset } = this.determineResponsiveValues();
        this.visibleItems = chosenVisibleItems;

        this.wrapper.style.setProperty('--peek', this.ensureUnit(chosenPeek));
        this.wrapper.style.setProperty('--gap', this.ensureUnit(chosenGap));
        this.updateColumnClass();

        requestAnimationFrame(() => {
            this.itemWidth = this.items[0].getBoundingClientRect().width;
            this.gapPx = this.convertToPx(chosenGap);
            this.offsetPx = this.convertToPx(chosenOffset);
            this.threshold = this.itemWidth * 0.2;

            if (this.enableArrows) this.updateArrowVisibility(); // Update arrow visibility on resize

            const stepSize = this.itemWidth + this.gapPx;
            const transformValue = this.offsetPx - (this.currentIndex * stepSize);
            this.wrapper.style.transform = `translateX(${transformValue}px)`; // Update transform position

            this.updateItemOpacity && this.updateItemOpacity(); // Update opacity after resize
        });
    }



    determineResponsiveValues() {
        const layoutKeys = Object.keys(this.responsiveLayout || {});
        if (layoutKeys.length === 0) {
            // No responsive layout, return defaults
            return {
                chosenVisibleItems: this.defaultVisibleItems,
                chosenPeek: this.peek,
                chosenGap: this.gap,
                chosenOffset: this.offset
            };
        }

        const breakpoints = layoutKeys.map(k => parseInt(k,10)).sort((a,b) => b - a);
        const viewportWidth = window.innerWidth;

        let chosenVisibleItems = this.defaultVisibleItems;
        let chosenPeek = this.peek;
        let chosenGap = this.gap;
        let chosenOffset = this.offset;

        for (let bp of breakpoints) {
            if (viewportWidth <= bp) {
                const layout = this.responsiveLayout[bp];
                if (layout.visibleItems !== undefined) chosenVisibleItems = layout.visibleItems;
                if (layout.peek !== undefined) chosenPeek = layout.peek;
                if (layout.gap !== undefined) chosenGap = layout.gap;
                if (layout.offset !== undefined) chosenOffset = layout.offset;
            }
        }

        return { chosenVisibleItems, chosenPeek, chosenGap, chosenOffset };
    }

    updateEnabledState() {
        const wasEnabled = this.isEnabled;
        const viewportWidth = window.innerWidth;
        const nowEnabled = !this.disabledBreakpoints.some(([min, max]) => {
            return viewportWidth >= min && viewportWidth <= max;
        });

        // If state hasn't changed, do nothing
        if (wasEnabled === nowEnabled) {
            return; // No state change, no need to enable/disable again
        }

        this.isEnabled = nowEnabled;

        if (!this.isEnabled) {
            // Transitioning from enabled to disabled
            this.container.classList.add('carousel-disabled');
            this.disableCarousel();
        } else {
            // Transitioning from disabled to enabled
            this.container.classList.remove('carousel-disabled');
            this.enableCarousel();
        }
    }


    enableCarousel() {
        // //console.log("enable");
        if (this.isEnabled) return;
        this.isEnabled = true;
        this.wrapper.classList.remove('columns-default');
        this.setupCarousel();
    }

    disableCarousel() {
        // //console.log("disable");
        // Removed the if check
        this.isEnabled = false;
        // //console.log("being disable");

        // Remove transition to avoid any animations
        this.wrapper.style.transition = 'none';

        // Reset position if needed
        this.currentIndex = 0;
        this.wrapper.style.transform = '';

        this.wrapper.classList.remove('columns-1','columns-2','columns-3','columns-4','columns-5');
        this.wrapper.classList.add('columns-default');

        const clones = this.wrapper.querySelectorAll('[aria-hidden="true"]');
        clones.forEach(clone => clone.remove());

        this.stopAutoSlide();

        const controls = this.container.querySelectorAll('.carousel-arrow');
        controls.forEach(control => (control.style.display = 'none'));
    }



    setupCarousel() {
        this.updateVisibleItems();
        this.updateColumnClass();
        this.addClones();

        const { chosenVisibleItems, chosenPeek, chosenGap, chosenOffset } = this.determineResponsiveValues();
        this.visibleItems = chosenVisibleItems;
        this.wrapper.style.setProperty('--peek', this.ensureUnit(chosenPeek));
        this.wrapper.style.setProperty('--gap', this.ensureUnit(chosenGap));

        requestAnimationFrame(() => {
            this.itemWidth = this.items[0].getBoundingClientRect().width;
            this.gapPx = this.convertToPx(chosenGap);
            this.offsetPx = this.convertToPx(chosenOffset);
            this.threshold = this.itemWidth * 0.2;

            if (this.enableArrows) {
                this.updateArrowVisibility();
            }

            if (this.autoSlide && this.shouldSlide()) this.startAutoSlide();
            this.preloadImages && this.preloadImages();
        });
    }

    addClones() {
        const existingClones = this.wrapper.querySelectorAll('[aria-hidden="true"]');
        existingClones.forEach(clone => clone.remove()); // Remove old clones

        if (!this.infinite) return; // No clones if not infinite

        // 1) Clone the last item and prepend it
        const lastItemClone = this.items[this.totalItems - 1].cloneNode(true);
        lastItemClone.setAttribute('aria-hidden', 'true');
        this.wrapper.insertBefore(lastItemClone, this.wrapper.firstChild);

        // 2) Conditionally add .my-cloned-item if hideFirstClone is true
        if (this.hideFirstClone) {
            lastItemClone.classList.add('my-cloned-item');
        }

        // 3) Existing logic to clone visibleItems + 2 items at the end
        for (let i = 0; i < this.visibleItems + 2; i++) {
            const originalIndex = i % this.totalItems;
            const clone = this.items[originalIndex].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            this.wrapper.appendChild(clone);
        }

        // Reapply opacity to ensure consistency
        this.updateItemOpacity && this.updateItemOpacity();
    }




    updateVisibleItems() {
        const viewportWidth = window.innerWidth;
        let matchedVisibleItems = this.defaultVisibleItems;

        const sortedBreakpoints = Object.entries(this.breakpoints).sort((a,b) => b[0]-a[0]);
        for (const [breakpoint, items] of sortedBreakpoints) {
            if (viewportWidth <= breakpoint) matchedVisibleItems = items;
        }

        this.visibleItems = matchedVisibleItems;
    }

    updateColumnClass() {
        this.wrapper.classList.remove('columns-1','columns-2','columns-3','columns-4','columns-5','columns-default');
        this.wrapper.classList.add(`columns-${this.visibleItems}`);
    }

    shouldSlide() {
        return this.totalItems > this.visibleItems;
    }

    addArrows() {
        // If we've already created arrows, do nothing
        if (this.prevArrow && this.nextArrow) return;

        // 1) Create a wrapper div for styling purposes
        const arrowWrapper = document.createElement('div');
        // base class
        arrowWrapper.classList.add('carousel-arrows-wrapper');
        // placement-specific modifier
        arrowWrapper.classList.add(`carousel-arrows-wrapper-${this.arrowPlacement}`);
        // You can style these classes in your CSS however you like

        // 2) Create the actual Prev and Next arrow buttons
        const prevArrow = document.createElement('button');
        prevArrow.classList.add('carousel-arrow', 'carousel-arrow-prev');

        const nextArrow = document.createElement('button');
        nextArrow.classList.add('carousel-arrow', 'carousel-arrow-next');

        // 3) Store them on the instance
        this.prevArrow = prevArrow;
        this.nextArrow = nextArrow;

        // 4) Append the arrows to the wrapper
        arrowWrapper.appendChild(prevArrow);
        arrowWrapper.appendChild(nextArrow);

        // 5) Decide where to place the wrapper based on user option
        switch (this.arrowPlacement) {
            case 'before': {
                const parentNode = this.container.parentNode;
                if (!parentNode) return;

                parentNode.insertBefore(arrowWrapper, this.container);
                break;
            }
            case 'after': {
                const parentNode = this.container.parentNode;
                if (!parentNode) return;

                const nextSibling = this.container.nextSibling;
                if (nextSibling) {
                    parentNode.insertBefore(arrowWrapper, nextSibling);
                } else {
                    parentNode.appendChild(arrowWrapper);
                }
                break;
            }
            case 'inside':
            default: {
                this.container.appendChild(arrowWrapper);
                break;
            }
        }

        // 6) Add click events
        prevArrow.addEventListener('click', () => {
            if (this.stopAutoSlide) this.stopAutoSlide();
            if (this.prevSlide) this.prevSlide();
        });

        nextArrow.addEventListener('click', () => {
            if (this.stopAutoSlide) this.stopAutoSlide();
            if (this.nextSlide) this.nextSlide();
        });
    }


    updateArrowVisibility() {
        // Ensure arrows exist
        if (!this.prevArrow || !this.nextArrow) return;

        // If there's nowhere to scroll, hide both
        if (!this.shouldSlide()) {
            this.prevArrow.style.display = 'none';
            this.nextArrow.style.display = 'none';
            return;
        } else {
            this.prevArrow.style.display = 'flex';
            this.nextArrow.style.display = 'flex';
        }

        // Infinite mode: always enable both (with special first-clone guard)
        if (this.infinite) {
            this.prevArrow.removeAttribute('disabled');
            this.nextArrow.removeAttribute('disabled');
            if (this.hideFirstClone && this.currentIndex === 1) {
                this.prevArrow.setAttribute('disabled', 'disabled');
            }
            return;
        }

        // Non-infinite mode: disable at the edges
        // Disable "prev" on first page
        if (this.currentIndex <= 0) {
            this.prevArrow.setAttribute('disabled', 'disabled');
        } else {
            this.prevArrow.removeAttribute('disabled');
        }

        // Disable "next" on last page (totalItems - visibleItems)
        const maxStart = this.totalItems - this.visibleItems;
        if (this.currentIndex >= maxStart) {
            this.nextArrow.setAttribute('disabled', 'disabled');
        } else {
            this.nextArrow.removeAttribute('disabled');
        }
    }







    startAutoSlide() {
        this.stopAutoSlide();
        this.intervalId = setInterval(() => this.nextSlide(), this.interval);
    }

    stopAutoSlide() {
        if (this.intervalId) clearInterval(this.intervalId);
        this.intervalId = null;
    }

    preloadImages() {
        const indexesToPreload = [
            this.currentIndex,
            (this.currentIndex + 1) % this.totalItems,
            (this.currentIndex - 1 + this.totalItems) % this.totalItems
        ];

        indexesToPreload.forEach((index) => {
            const item = this.wrapper.children[index];
            if (item) {
                const pictures = item.querySelectorAll('picture');
                pictures.forEach((picture) => {
                    const sources = picture.querySelectorAll('source[data-srcset]');
                    sources.forEach((source) => {
                        if (!source.srcset) {
                            source.srcset = source.getAttribute('data-srcset');
                            source.removeAttribute('data-srcset');
                        }
                    });

                    const img = picture.querySelector('img.lazy:not(.loaded)');
                    if (img && img.getAttribute('data-src')) {
                        img.src = img.getAttribute('data-src');
                        img.classList.add('loaded');
                        img.removeAttribute('data-src');
                    }
                });
            }
        });
    }

    goToSlide(index) {
        if (!this.isEnabled) return;
        this.stopAutoSlide();

        // use same offset as updateActiveJumpLink: 1 for infinite (skip clone), 0 otherwise
        const offset = this.infinite ? 1 : 0;
        let realIndex = index + offset;

        // in infinite mode, clicking the last jump (index = totalItems-1) should go to the fake last slide
        if (this.infinite && index === this.totalItems - 1) {
            realIndex = this.totalItems;
        }

        this.currentIndex = realIndex;
        this.updateArrowVisibility && this.updateArrowVisibility();

        // calculate and apply the translateX value
        const stepSize = this.itemWidth + this.gapPx;
        const transformValue = this.offsetPx - (realIndex * stepSize);
        this.wrapper.style.transition = `transform ${this.transitionDuration}ms ease-in-out`;
        this.wrapper.style.transform = `translateX(${transformValue}px)`;

        // refresh controls, links, and opacity after jump
        this.preloadImages && this.preloadImages();
        this.updateActiveJumpLink && this.updateActiveJumpLink();
        this.updateItemOpacity && this.updateItemOpacity();
    }




    nextSlide() {
        // 1) Prevent overlapping transitions
        if (this.isAnimating) return;
        this.isAnimating = true;

        const stepSize = this.itemWidth + this.gapPx;

        // 2) Non-infinite + autoSlide: when we've reached the last page,
        //    animate a “rewind” back to the first slide instead of overscrolling.
        if (!this.infinite && this.autoSlide) {
            const maxStart = this.totalItems - this.visibleItems;
            if (this.currentIndex >= maxStart) {
                // Animate from last page directly back to the start (index=0)
                this.wrapper.style.transition = `transform ${this.transitionDuration}ms ease-in-out`;
                this.wrapper.style.transform = `translateX(${this.offsetPx}px)`; // offsetPx is slide 0

                // After animation, reset state and re-enable controls
                setTimeout(() => {
                    this.currentIndex = 0;
                    this.updateArrowVisibility && this.updateArrowVisibility();
                    this.updateActiveJumpLink && this.updateActiveJumpLink();
                    this.updateItemOpacity && this.updateItemOpacity();
                    this.isAnimating = false;
                }, this.transitionDuration);

                return;
            }
        }

        // 3) Advance index by one for normal scrolling
        this.currentIndex++;

        // 4) Perform the slide transform
        const transformValue = this.offsetPx - (this.currentIndex * stepSize);
        this.wrapper.style.transition = `transform ${this.transitionDuration}ms ease-in-out`;
        this.wrapper.style.transform = `translateX(${transformValue}px)`;

        // 5) Update arrow controls
        this.updateArrowVisibility && this.updateArrowVisibility();

        // 6) Infinite wrap logic (unchanged)
        if (this.infinite && this.currentIndex >= (this.totalItems + 1)) {
            setTimeout(() => {
                this.wrapper.style.transition = 'none';
                this.currentIndex = 1;
                const resetTransform = this.offsetPx - (this.currentIndex * stepSize);
                this.wrapper.style.transform = `translateX(${resetTransform}px)`;

                const firstCloned = this.wrapper.querySelector('.my-cloned-item');
                if (firstCloned) {
                    firstCloned.classList.remove('my-cloned-item');
                    this.updateArrowVisibility && this.updateArrowVisibility();
                }

                // force reflow
                this.wrapper.offsetHeight;

                // re-enable transition
                requestAnimationFrame(() => {
                    this.wrapper.style.transition =
                        `transform ${this.transitionDuration}ms ease-in-out`;
                });

                this.updateActiveJumpLink && this.updateActiveJumpLink();
                this.updateItemOpacity && this.updateItemOpacity();
                this.isAnimating = false;
            }, this.transitionDuration);

        } else {
            // 7) Normal end-of-slide housekeeping
            this.updateActiveJumpLink && this.updateActiveJumpLink();
            this.updateItemOpacity && this.updateItemOpacity();
            this.preloadImages && this.preloadImages();

            setTimeout(() => {
                this.isAnimating = false;
            }, this.transitionDuration);
        }
    }








    prevSlide() {
        // 1) No slide if there aren't enough items
        if (!this.shouldSlide()) return;

        const stepSize = this.itemWidth + this.gapPx;

        // 2) Decrement currentIndex
        this.currentIndex--;

        //update arrowvisibility
        this.updateArrowVisibility && this.updateArrowVisibility();

        // 3) TWO-STEP LOGIC WHEN AT index=0/1
        // -------------------------------------------------------
        // If infinite is ON and we land at index=0 or index < 0,
        // we want to do a *fake* backward wrap so the user sees an animation.
        if (this.infinite && this.currentIndex <= 0) {
            // Step A: Jump instantly to the "fake end" (index = this.totalItems + 1)
            this.wrapper.style.transition = 'none';
            this.currentIndex = this.totalItems + 1;

            const jumpTransform = this.offsetPx - (this.currentIndex * stepSize);
            this.wrapper.style.transform = `translateX(${jumpTransform}px)`;

            // Re-enable transition on next frame, then animate backward to last item
            requestAnimationFrame(() => {
                // Step B: Animate from the fake end down to the last real item
                this.wrapper.style.transition = `transform ${this.transitionDuration}ms ease-in-out`;
                this.currentIndex = this.totalItems; // The last real item
                const animTransform = this.offsetPx - (this.currentIndex * stepSize);
                this.wrapper.style.transform = `translateX(${animTransform}px)`;

                // Update after the animation target is set
                this.updateActiveJumpLink && this.updateActiveJumpLink();
                this.updateItemOpacity && this.updateItemOpacity();
                this.preloadImages && this.preloadImages();
            });

            return; // IMPORTANT: Stop here so no other logic runs
        }
        // -------------------------------------------------------

        // 4) Normal backward sliding (if not infinite or currentIndex > 0)
        const transformValue = this.offsetPx - (this.currentIndex * stepSize);
        this.wrapper.style.transition = `transform ${this.transitionDuration}ms ease-in-out`;
        this.wrapper.style.transform = `translateX(${transformValue}px)`;

        // 5) Updates
        this.updateActiveJumpLink && this.updateActiveJumpLink();
        this.updateItemOpacity && this.updateItemOpacity();
        this.preloadImages && this.preloadImages();
    }





    createJumpLinks() {
        // Remove any existing jump-links container
        let ctr = this.container.querySelector('.carousel-jump-links');
        if (ctr) ctr.remove();

        // Create a new container for the dots
        ctr = document.createElement('div');
        ctr.classList.add('carousel-jump-links');
        this.jumpLinks = [];

        // Determine how many “pages” we need:
        // - Non-infinite: pageCount = totalItems - visibleItems + 1
        //   (each page is one valid starting position, so no empty gap)
        // - Infinite: one dot per slide preserves wrap-around behavior
        const pageCount = this.infinite
            ? this.totalItems
            : Math.max(1, this.totalItems - this.visibleItems + 1);

        // Generate each dot
        for (let page = 0; page < pageCount; page++) {
            const btn = document.createElement('button');
            btn.classList.add('carousel-jump-link');

            // Use a bullet, or you could label “1”, “2”, etc.
            btn.textContent = '•';

            // When clicked, jump to that page’s starting slide
            btn.addEventListener('click', () => this.goToSlide(page));

            ctr.appendChild(btn);
            this.jumpLinks.push(btn);
        }

        // Append the new dots container to the carousel
        this.container.appendChild(ctr);

        // Highlight the correct dot for the initial position
        this.updateActiveJumpLink();
    }

    attachCustomLinks() {
        // collect external links (don’t mix them into jumpLinks)
        const custom = document.querySelectorAll(this.customLinksSelector);
        this.customLinks = Array.prototype.slice.call(custom);

        this.customLinks.forEach((link, i) => {
            // prefer data-slide, fallback to loop index
            const slideIndex = parseInt(link.getAttribute('data-slide'), 10);
            const idx = isNaN(slideIndex) ? i : slideIndex;

            link.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.stopAutoSlide) this.stopAutoSlide();
                this.goToSlide(idx);
            });
        });

        // sync initial state
        this.updateActiveJumpLink && this.updateActiveJumpLink();
    }



    updateActiveJumpLink() {
        // nothing to toggle
        if (!this.jumpLinks && (!this.customLinks || this.customLinks.length === 0)) return;

        let activeIndex;

        if (this.infinite) {
            // currentIndex includes the prepended clone at 0, so subtract 1
            activeIndex = (this.currentIndex - 1 + this.totalItems) % this.totalItems;
            if (this.currentIndex >= this.totalItems + 1) activeIndex = 0;
        } else {
            // clamp to valid start positions in non-infinite mode
            const maxStart = Math.max(0, this.totalItems - this.visibleItems);
            activeIndex = Math.min(Math.max(0, this.currentIndex), maxStart);
        }

        const toggle = (el, isOn) => {
            if (!el) return;
            el.classList.toggle('active', isOn);
            el.classList.toggle('is-active', isOn);     // support either classname
            el.setAttribute('aria-selected', isOn ? 'true' : 'false');
        };

        // internal dots (if you enabled them)
        if (this.jumpLinks && this.jumpLinks.length) {
            this.jumpLinks.forEach((btn, i) => toggle(btn, i === activeIndex));
        }

        // your external nav buttons
        if (this.customLinks && this.customLinks.length) {
            // assume one custom button per logical slide (0..totalItems-1)
            this.customLinks.forEach((btn, i) => toggle(btn, i === activeIndex));
        }
    }




    addInteractionEvents() {
        // Create a Hammer instance for the wrapper element
        const hammer = new Hammer(this.wrapper);

        // Configure the pan gesture for dragging/swiping
        hammer.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL });

        // Debugging for Hammer instance setup
        //console.log('Hammer.js instance created for:', this.wrapper);

        // Handle pan (drag/swipe) events
        hammer.on('pan', (e) => {
            // console.log('Pan detected:', {
            //     deltaX: e.deltaX,
            //     direction: e.direction,
            //     distance: e.distance,
            //     velocityX: e.velocityX
            // });

            // Stop auto-slide when user interacts
            this.stopAutoSlide();

            const stepSize = this.itemWidth + this.gapPx;
            const transformValue = this.offsetPx - this.currentIndex * stepSize + e.deltaX;
            this.wrapper.style.transform = `translateX(${transformValue}px)`;
        });

        // Handle pan end (when dragging stops)
        hammer.on('panend', (e) => {
            // console.log('Panend detected:', {
            //     deltaX: e.deltaX,
            //     direction: e.direction,
            //     distance: e.distance,
            //     velocityX: e.velocityX
            // });

            const stepSize = this.itemWidth + this.gapPx;

            if (e.deltaX < -this.threshold) {
                this.nextSlide(); // Swipe left
            } else if (e.deltaX > this.threshold) {
                this.prevSlide(); // Swipe right
            } else {
                // Reset to current position if threshold not met
                const transformValue = this.offsetPx - (this.currentIndex * stepSize);
                this.wrapper.style.transition = `transform ${this.transitionDuration}ms ease-in-out`;
                this.wrapper.style.transform = `translateX(${transformValue}px)`;
            }
        });

        // Optional: Handle tap for any additional features
        hammer.on('tap', () => {
            //console.log('Tapped on the slider');
        });
    }

    updateItemOpacity() {
        if (!this.reduceOpacity) return; // Exit if reduceOpacity is disabled

        // Combine original items and clones
        const allItems = Array.from(this.wrapper.children);

        allItems.forEach((item, index) => {
            // Determine if the item is within the visible range
            const isActive = index >= this.currentIndex && index < this.currentIndex + this.visibleItems;

            // Apply opacity based on active state
            item.style.opacity = isActive ? '1' : '0.5';
        });
    }

    ensureUnit(value) {
        if (value === '0' || value.trim() === '0') return '0px';
        return value;
    }

    convertToPx(valueStr) {
        if (!valueStr || valueStr.trim() === '0' || valueStr.trim() === '0px') {
            return 0;
        }
        const str = valueStr.trim();

        // handle calc(...) with only vw and px
        if (str.startsWith('calc(') && str.endsWith(')')) {
            let expr = str.slice(5, -1);

            // 1) turn NNNvw → (innerWidth * NNN/100)
            expr = expr.replace(/([\d.]+)vw/g, (_, n) =>
                (window.innerWidth * parseFloat(n) / 100)
            );

            // 2) turn MMMpx → MMM
            expr = expr.replace(/([\d.]+)px/g, (_, n) =>
                parseFloat(n)
            );

            // now it’s purely numeric—eval it
            try {
                return Function(`"use strict"; return (${expr})`)();
            } catch (e) {
                console.error('Error parsing calc():', expr, e);
                return NaN;
            }
        }

        // fallback for simple vw/px/% values
        const value = parseFloat(str);
        const unit  = str.replace(value, '').trim();
        if (unit === 'px' || unit === '') return value;
        if (unit === 'vw')  return (window.innerWidth * value) / 100;
        if (unit === '%')   return (this.container.clientWidth * value) / 100;

        return value; // NaN if unparsable
    }

}


// USPs
document.addEventListener('DOMContentLoaded', () => {
    const uspsSmall = document.querySelector('.usps--small .usps-ctr-inner');
    if (uspsSmall) {
        new Carousel('.usps--small .usps-slider', {
            interval: 4000,
            transitionDuration: 500,
            visibleItems: 4,
            infinite: true,
            autoSlide: true,
            reduceOpacity: false,
            gap: '24px',
            peek: '0',
            offset: '0',
            hideFirstClone: true,
            disabledBreakpoints: [
                [1601, Infinity]
            ],
            responsiveLayout: {
                1600: { 
                    visibleItems: 3,
                },
                1279: {
                    visibleItems: 2,
                },
                768:  { 
                    visibleItems: 1,
                },
            },
            enableArrows: false,
            enableJumpLinks: false,
        });
    }
});

// USPs Large:
document.addEventListener('DOMContentLoaded', () => {
    const uspsLarge = document.querySelector('.usps--large .usps-slider');
    if (uspsLarge) {
        new Carousel('.usps--large .usps-slider', {
            interval: 5000,
            transitionDuration: 500,
            visibleItems: 4,
            infinite: true,
            autoSlide: true,
            gap: '24px',
            peek: '0',
            offset: '0',
            disabledBreakpoints: [
                [1601, Infinity]
            ],
            // enableArrows: true,
            // arrowPlacement: 'before', // or 'after' or 'inside'
            // enableJumpLinks: true,
            // customLinksSelector: '.jump-link',
            autoSlide: true,
            responsiveLayout: {
                1600: { 
                    visibleItems: 3,
                },
                1279: { 
                    visibleItems: 2,
                },
                768:  { 
                    visibleItems: 1,
                }
            }
        });
    }
});

// Manufacturers
document.addEventListener('DOMContentLoaded', () => {
    const manufacturers = document.querySelector('.manufacturer-strip');
    if (manufacturers) {
        new Carousel('.manufacturer-strip', {
            autoSlide: false,
            visibleItems: 7,
            infinite: true,
            hideFirstClone: true,
            reduceOpacity: true,
            gap: '16px',
            peek: 'calc(((100vw - 1660px) / 2 + 48px) * 2)', // peek is offset * 2 - but with the gap removed
            offset: 'calc((100vw - 1660px) / 2 + 48px - 16px)', // 1660px is the narrow ctr max width, 48px is the padding and 16px is the element gap
            responsiveLayout: {
                1692: {
                    peek: '96px',
                    offset: '48px'
                },
                1600: { 
                    visibleItems: 6
                },
                1280: { 
                    peek: '64px',
                    offset: '32px'
                },
                1024: {
                    visibleItems: 5,
                },
                640:  { 
                    visibleItems: 4,
                },
                480:  { 
                    visibleItems: 2,
                    peek: '48px',
                    offset: '24px'
                }
            },
            enableArrows: true,
            arrowPlacement: 'before', // 'before' or 'after' or 'inside'
            enableJumpLinks: false
        });
    }
});

// Bodytypes
document.addEventListener('DOMContentLoaded', () => {
    const bodytype = document.querySelector('.bodytype-strip');
    if (bodytype) {
        new Carousel('.bodytype-strip', {
            autoSlide: false,
            visibleItems: 7,
            infinite: true,
            hideFirstClone: true,
            reduceOpacity: true,
            gap: '16px',
            peek: 'calc(((100vw - 1660px) / 2 + 48px) * 2)', // peek is offset * 2 - but with the gap removed because it's on the last item
            offset: 'calc((100vw - 1660px) / 2 + 48px - 16px)', // 1660px is the narrow ctr max width, 48px is the padding and 16px is the element gap
            responsiveLayout: {
                1692: {
                    peek: '96px',
                    offset: '48px'
                },
                1600: { 
                    visibleItems: 6
                },
                1280: { 
                    peek: '64px',
                    offset: '32px'
                },
                1024: {
                    visibleItems: 5,
                },
                640:  { 
                    visibleItems: 4,
                },
                480:  { 
                    visibleItems: 2,
                    peek: '48px',
                    offset: '24px'
                }
            },
            enableArrows: true,
            arrowPlacement: 'before', // 'before' or 'after' or 'inside'
            enableJumpLinks: false
        });
    }
});

// Latest Offers
document.addEventListener('DOMContentLoaded', () => {
    const latestOffers = document.querySelector('.offers-strip-slider');
    if (latestOffers) {
        new Carousel('.offers-strip-slider', {
            interval: 8000,
            transitionDuration: 300,
            visibleItems: 3,
            infinite: false,
            reduceOpacity: true,
            gap: '16px',
            peek: 'calc(((100vw - 1660px) / 2 + 48px - 16px) * 2)', // peek is offset * 2 - but with the gap removed
            offset: 'calc((100vw - 1660px) / 2 + 48px - 16px)', // 1660px is the narrow ctr max width, 48px is the padding and 16px is the element gap
            responsiveLayout: {
                1692: {
                    peek: '96px',
                    offset: '48px'
                },
                1280: { 
                    peek: '64px',
                    offset: '32px'
                },
                1279: { 
                    visibleItems: 2,
                },
                640:  { 
                    visibleItems: 1,
                },
                480:  { 
                    peek: '48px',
                    offset: '24px'
                }
            },
            enableArrows: true,
            arrowPlacement: 'inside', // or 'after' or 'inside'
            enableJumpLinks: true
        });
    }
});

// Reviews Strip
document.addEventListener('DOMContentLoaded', () => {
    const reviewsStrip = document.querySelector('.reviews-strip-slider');
    if (reviewsStrip) {
        new Carousel('.reviews-strip-slider', {
            interval: 8000,
            transitionDuration: 300,
            visibleItems: 3,
            infinite: true,
            reduceOpacity: true,
            gap: '16px',
            peek: 'calc(((100vw - 1660px) / 2 + 48px - 16px) * 2)', // peek is offset * 2 - but with the gap removed
            offset: 'calc((100vw - 1660px) / 2 + 48px - 16px)', // 1660px is the narrow ctr max width, 48px is the padding and 16px is the element gap
            responsiveLayout: {
                1692: {
                    peek: '96px',
                    offset: '48px'
                },
                1280: { 
                    peek: '64px',
                    offset: '32px'
                },
                1279: { 
                    visibleItems: 2,
                },
                640:  { 
                    visibleItems: 1,
                },
                480:  { 
                    peek: '48px',
                    offset: '24px'
                }
            },
            enableArrows: true,
            arrowPlacement: 'inside', // or 'after' or 'inside'
            enableJumpLinks: false
        });
    }
});

// Reviews Strip
document.addEventListener('DOMContentLoaded', () => {
    const crusaderStrip = document.querySelector('.crusader-choice-slider');
    if (crusaderStrip) {
        new Carousel('.crusader-choice-slider', {
            interval: 8000,
            transitionDuration: 300,
            visibleItems: 1,
            infinite: true,
            reduceOpacity: true,
            gap: '16px',
            peek: 'calc(((100vw - 1660px) / 2 + 48px - 16px) * 2)', // peek is offset * 2 - but with the gap removed
            offset: 'calc((100vw - 1660px) / 2 + 48px - 16px)', // 1660px is the narrow ctr max width, 48px is the padding and 16px is the element gap
            responsiveLayout: {
                1692: {
                    peek: '96px',
                    offset: '48px'
                },
                1280: { 
                    peek: '64px',
                    offset: '32px'
                },
                480:  { 
                    peek: '48px',
                    offset: '24px'
                }
            },
            enableArrows: true,
            arrowPlacement: 'inside', // or 'after' or 'inside'
            enableJumpLinks: true,
            customLinksSelector: '.jump-link',
        });
    }
});

// Latest News
document.addEventListener('DOMContentLoaded', () => {
    const latestOffers = document.querySelector('.latest-blog-slider');
    if (latestOffers) {
        new Carousel('.latest-blog-slider', {
            interval: 8000,
            transitionDuration: 300,
            visibleItems: 2,
            infinite: false,
            reduceOpacity: true,
            gap: '16px',
            peek: 'calc(((100vw - 1660px) / 2 + 48px) * 2)', // peek is offset * 2 - but with the gap removed
            offset: 'calc((100vw - 1660px) / 2 + 48px - 16px)', // 1660px is the narrow ctr max width, 48px is the padding and 16px is the element gap
            responsiveLayout: {
                1692: {
                    peek: '96px',
                    offset: '48px'
                },
                1280: { 
                    peek: '64px',
                    offset: '32px'
                },

                640:  { 
                    visibleItems: 1,
                },
                480:  { 
                    peek: '48px',
                    offset: '24px'
                }
            },
            enableArrows: false,
            arrowPlacement: 'inside', // or 'after' or 'inside'
            enableJumpLinks: true
        });
    }
});

// Range Specs
document.addEventListener('DOMContentLoaded', () => {
    const latestOffers = document.querySelector('.range-specs-strip');
    if (latestOffers) {
        new Carousel('.range-specs-strip', {
            interval: 8000,
            transitionDuration: 300,
            visibleItems: 3,
            infinite: false,
            reduceOpacity: true,
            gap: '16px',
            peek: 'calc(((100vw - 1660px) / 2 + 48px - 16px) * 2)', // peek is offset * 2 - but with the gap removed
            offset: 'calc((100vw - 1660px) / 2 + 48px - 16px)', // 1660px is the narrow ctr max width, 48px is the padding and 16px is the element gap
            responsiveLayout: {
                1692: {
                    peek: '96px',
                    offset: '48px'
                },
                1280: { 
                    peek: '64px',
                    offset: '32px'
                },
                1279: { 
                    visibleItems: 2,
                },
                640:  { 
                    visibleItems: 1,
                },
                480:  { 
                    peek: '48px',
                    offset: '24px'
                }
            },
            enableArrows: true,
            arrowPlacement: 'before', // 'before' or 'after' or 'inside'
            enableJumpLinks: false
        });
    }
});



// Usage example:
// document.addEventListener('DOMContentLoaded', () => {
//     new Carousel('.reviews-block-aside', {
//         interval: 5000,
//         transitionDuration: 400,
//         visibleItems: 3,
//         infinite: true,
//         hideFirstClone: true,
//         disabledBreakpoints: [
//             [1400, Infinity]
//         ],
//         enableArrows: true,
//         arrowPlacement: 'before' // or 'after' or 'inside'
//         enableJumpLinks: true,
//         customLinksSelector: '.jump-link',
//         peek: '5vw',
//         gap: '20px',
//         offset: '5vw', // offset for initial positioning
//         autoSlide: true,
//         responsiveLayout: {
//             1400: { 
//                 visibleItems: 3,
//                 peek: '10vw', 
//                 gap: '20px', 
//                 offset: '5vw' 
//             },
//             1024: { 
//                 visibleItems: 2,
//                 peek: '5vw',  
//                 gap: '10px', 
//                 offset: '2vw' 
//             },
//             768:  { 
//                 visibleItems: 1,
//                 peek: '0px',  
//                 gap: '0px',  
//                 offset: '0px' 
//             }
//         }
//     });
// });




;(function () {
    document.querySelectorAll('.tabs').forEach(initTabs);

    function initTabs(tabsContainer) {
        const panelsEl = tabsContainer.querySelector('.tabs--panels');
        const triggers = Array.from(tabsContainer.querySelectorAll('.tabs--trigger'));
        const panels   = panelsEl ? Array.from(panelsEl.querySelectorAll('.tabs--panel')) : [];

        // If essential parts are missing, skip this instance
        if (!panelsEl || triggers.length === 0 || panels.length === 0) return;

        // Wire tab buttons
        triggers.forEach(btn => {
            btn.addEventListener('click', () => switchTab(tabsContainer, btn));
        });

        // Equalize container height to the tallest panel
        const updateHeights = () => {
            const activeBtn = tabsContainer.querySelector('.tabs--trigger[aria-selected="true"]');
            const activeTarget = activeBtn ? activeBtn.dataset.target : null;

            let maxH = 0;

            // Temporarily hide all panels to measure each
            panels.forEach(panel => { panel.hidden = true; });

            panels.forEach(panel => {
                panel.hidden = false;
                const h = panelsEl.offsetHeight || 0;
                if (h > maxH) maxH = h;
                panel.hidden = true;
            });

            // Restore previously active panel
            if (activeTarget) {
                const activePanel = panelsEl.querySelector(`.tabs--panel[data-panel="${activeTarget}"]`);
                if (activePanel) activePanel.hidden = false;
            }

            panelsEl.style.minHeight = maxH + 'px';
        };

        // Fallback debounce if none is available on the page
        const _debounce = (typeof debounce === 'function')
            ? debounce
            : (fn, wait = 100) => {
                  let t;
                  return (...args) => {
                      clearTimeout(t);
                      t = setTimeout(() => fn.apply(null, args), wait);
                  };
              };

        updateHeights();
        window.addEventListener('resize', _debounce(updateHeights, 100));

        // Activate first (or preselected) tab
        const initial = triggers.find(btn => btn.getAttribute('aria-selected') === 'true') || triggers[0];
        if (initial) switchTab(tabsContainer, initial);
    }

    function switchTab(container, clickedBtn) {
        if (!clickedBtn) return;

        const panelsEl = container.querySelector('.tabs--panels');
        const triggers = Array.from(container.querySelectorAll('.tabs--trigger'));
        const panels   = panelsEl ? Array.from(container.querySelectorAll('.tabs--panel')) : [];

        if (!panelsEl || triggers.length === 0 || panels.length === 0) return;

        // Deactivate all tabs and hide all panels
        triggers.forEach(btn => btn.setAttribute('aria-selected', 'false'));
        panels.forEach(panel => { panel.hidden = true; });

        // Activate clicked tab and show its target panel
        clickedBtn.setAttribute('aria-selected', 'true');
        const target = clickedBtn.dataset.target;
        const show = target ? container.querySelector(`.tabs--panel[data-panel="${target}"]`) : null;
        if (show) show.hidden = false;

        // Add .first-active when the first tab is selected
        const isFirst = clickedBtn === triggers[0];
        panelsEl.classList.toggle('first-active', !!isFirst);
    }
})();

/* Legacy .tab-list/.tab support (safe if not present) */
document.querySelectorAll('.tabs').forEach(tabs => {
    const list  = tabs.querySelector('.tab-list');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('.tab'));

    const apply = () => {
        const firstIsActive = items[0] && items[0].classList.contains('active');
        tabs.classList.toggle('first-active', !!firstIsActive);
    };

    apply();

    list.addEventListener('click', e => {
        if (!e.target.closest('.tab')) return;
        // Wait for any inline tab logic to toggle classes, then recalc
        setTimeout(apply);
    });
});



// derivative gallery thumbnail clicks
document.querySelectorAll('.deal-gallery').forEach(gallery => {
    const thumbs   = gallery.querySelectorAll('.gallery-thumb');
    const mainImgs = gallery.querySelectorAll('.deal-gallery-img');
    const mainWrap = gallery.querySelector('.deal-gallery-main');

    if (!thumbs.length || !mainImgs.length) return;

    thumbs.forEach((thumb, idx) => {
        thumb.addEventListener('click', e => {
            e.preventDefault();

            // active state
            thumbs.forEach(t => t.classList.remove('is-active'));
            thumb.classList.add('is-active');

            // swap image
            const url = thumb.dataset.img;
            mainImgs.forEach(img => {
                img.src = url;
                img.srcset = `${url} 1x, ${url} 2x`; // keep simple; adjust if you have real 2x
                const thumbImg = thumb.querySelector('img');
                if (thumbImg && thumbImg.alt) img.alt = thumbImg.alt;
            });

            // optional video trigger (only if you add .has-video to the gallery)
            if (gallery.classList.contains('has-video') && mainWrap) {
                if (idx === 0) mainWrap.classList.add('video-trigger');
                else mainWrap.classList.remove('video-trigger');
            }
        });
    });
});


// Masonry with "2-col can go right of a 1-col" on 3-column rows
(function () {
  function masonryWithLookahead(container, row = 1) {
    const grid = typeof container === 'string' ? document.querySelector(container) : container;
    if (!grid) return;

    const colsCount = () => {
      const s = getComputedStyle(grid).gridTemplateColumns || '';
      return s.split(' ').filter(Boolean).length || 1;
    };

    const measureRows = (el) => {
      const target = el.querySelector('.card-ctr') || el;
      const dpr = window.devicePixelRatio || 1;
      const hPx = target.getBoundingClientRect().height;
      const h = Math.round(hPx * dpr) / dpr;
      // row-gap is 0 in CSS; span is ceil(height / row)
      return Math.max(1, Math.ceil((h - 0.1) / row));
    };

    const clearPos = (els) => els.forEach(el => { el.style.gridColumn = ''; el.style.gridRow = ''; el.style.gridRowEnd = ''; });

    // General packed layout for n>=2 columns
    const layoutPacked = (n) => {
      const items = Array.from(grid.children);
      clearPos(items);

      const heights = new Array(n).fill(0); // per-column height in row units

      const placeW1 = (el, h) => {
        let k = 0;
        for (let i = 1; i < n; i++) if (heights[i] < heights[k]) k = i;
        const start = heights[k] + 1;
        el.style.gridColumn = `${k + 1} / span 1`;
        el.style.gridRow = `${start} / span ${h}`;
        heights[k] += h;
      };

      const placeW2At = (el, h, startCol) => {
        const start = Math.max(...heights.slice(startCol - 1, startCol + 1)) + 1;
        el.style.gridColumn = `${startCol} / span 2`;
        el.style.gridRow = `${start} / span ${h}`;
        const newH = start - 1 + h;
        heights[startCol - 1] = newH;
        heights[startCol] = newH;
      };

      items.forEach((el, idx) => {
        const w = el.classList.contains('span-2') ? Math.min(2, n) : 1;
        const h = measureRows(el);

        if (w === 1) {
          placeW1(el, h);
        } else {
          // choose best adjacent pair
          let bestStart = 1, bestHeight = Infinity;
          for (let s = 1; s <= n - 1; s++) {
            const pairH = Math.max(heights[s - 1], heights[s]);
            if (pairH < bestHeight) { bestHeight = pairH; bestStart = s; }
          }

          // Desktop 3-col lookahead: if starting a fresh row (all equal)
          // and the next item is 1-col, bias to columns 2–3.
          if (n === 3 && heights[0] === heights[1] && heights[1] === heights[2]) {
            const next = items[idx + 1];
            if (next && !next.classList.contains('span-2')) bestStart = 2;
          }

          placeW2At(el, h, bestStart);
        }
      });
    };

    // Fallback simple layout for 1 column
    const layoutSimple = () => {
      const items = Array.from(grid.children);
      clearPos(items);
      items.forEach(el => { el.style.gridRowEnd = `span ${measureRows(el)}`; });
    };

    function layout() {
      const n = colsCount();
      if (n >= 2) layoutPacked(n);
      else layoutSimple();
    }

    new ResizeObserver(layout).observe(grid);
    grid.querySelectorAll('img').forEach(img => { if (!img.complete) img.addEventListener('load', layout, { once: true }); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    addEventListener('resize', layout);
    addEventListener('load', layout);

    layout();
    return { layout };
  }

  // Init — must match CSS: .masonry { grid-auto-rows: 1px; row-gap: 0; }
  window.mason = masonryWithLookahead('.masonry', 1);
})();

/*global fetch */
/*global window */
/*global document */

(function () {
  const CAR_ENDPOINT = '/api/car/get-deal-by-search-auto-profiles';
  const VAN_ENDPOINT = '/api/van/get-deal-by-search-auto-profiles';
  const TABLE_SELECTOR = '.model-table-range';
  const PRICE_SELECTOR = '.js-price[data-cap-id]';

  function getEndpoint(table) {
    const vehicleType = (table && table.dataset && table.dataset.vehicleType) || '';
    if (/van/i.test(vehicleType)) {
      return VAN_ENDPOINT;
    }

    return /\/van-/i.test(window.location.pathname) ? VAN_ENDPOINT : CAR_ENDPOINT;
  }

  function getSelectedPriceType() {
    const personalToggle = document.querySelector('.price-toggle .toggle-personal:checked');
    if (personalToggle) {
      return 'personal';
    }

    const businessToggle = document.querySelector('.price-toggle .toggle-business:checked');
    if (businessToggle) {
      return 'business';
    }

    const bodyType = (document.body && document.body.dataset && document.body.dataset.type) || '';
    return /personal/i.test(bodyType) ? 'personal' : 'business';
  }

  function parseCapId(value) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function formatPrice(value) {
    return new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  function buildRequestPayload(capIds) {
    const payload = { ids: capIds };
    const passthroughKeys = [
      'term',
      'mileage',
      'stock_price',
      'stock_pipeline',
      'special_offer',
      'used_price',
      'initial_profile',
      'profile',
      'maintenance',
      'bad_credit',
      'ratebooks'
    ];

    const params = new URLSearchParams(window.location.search);
    passthroughKeys.forEach((key) => {
      if (params.has(key)) {
        payload[key] = params.get(key);
      }
    });

    return payload;
  }

  function updatePriceCells(priceCells, dealsByCapId) {
    const selectedType = getSelectedPriceType();

    priceCells.forEach((cell) => {
      const capId = parseCapId(cell.dataset.capId);
      if (!capId) {
        cell.textContent = 'N/A';
        return;
      }

      const row = cell.closest('.model-table-row');
      const deal = dealsByCapId[String(capId)] || dealsByCapId[capId];
      const priceData = selectedType === 'personal'
        ? deal && deal.personal_price
        : deal && deal.business_price;
      const monthlyRental = priceData && priceData.monthly_rental;
      const numericPrice = monthlyRental !== null && monthlyRental !== undefined
        ? parseFloat(monthlyRental)
        : NaN;

      if (Number.isFinite(numericPrice)) {
        cell.textContent = '£' + formatPrice(numericPrice);
        if (row) {
          row.dataset.price = numericPrice.toFixed(2);
        }
      } else {
        cell.textContent = 'POA';
        if (row) {
          row.dataset.price = '';
        }
      }
    });
  }

  async function loadPrices() {
    const table = document.querySelector(TABLE_SELECTOR);
    if (!table) {
      return;
    }

    const endpoint = getEndpoint(table);

    const priceCells = Array.from(table.querySelectorAll(PRICE_SELECTOR));
    if (!priceCells.length) {
      return;
    }

    const capIds = Array.from(new Set(
      priceCells
        .map((cell) => parseCapId(cell.dataset.capId))
        .filter((capId) => capId !== null)
    ));

    if (!capIds.length) {
      priceCells.forEach((cell) => {
        cell.textContent = 'N/A';
      });
      return;
    }

    const payload = buildRequestPayload(capIds);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Price request failed with status ' + response.status);
      }

      const data = await response.json();
      const dealsByCapId = data && data.deals ? data.deals : {};

      updatePriceCells(priceCells, dealsByCapId);

      const onPriceTypeToggle = function () {
        updatePriceCells(priceCells, dealsByCapId);
      };

      document.querySelectorAll('.price-toggle .toggle-personal, .price-toggle .toggle-business, .price-toggle .price-toggle-checkbox')
        .forEach((toggle) => {
          toggle.addEventListener('change', onPriceTypeToggle);
          toggle.addEventListener('click', onPriceTypeToggle);
        });
    } catch (error) {
      console.error('Failed loading range model table prices:', error);
      priceCells.forEach((cell) => {
        cell.textContent = 'N/A';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', loadPrices);
})();
